'use strict';
const imageFile = 'https://cdn.shopify.com/s/files/1/0743/0894/4182/files/';
const tariffsActive = {
  FW: false,
  KL: false,
};
const date = new Date();
const date30 = new Date();
date30.setDate(date30.getDate() + 30);
const saveNewRug = function() {
  if (requiredFields.every(val => val !== '') && requiredFields.every(val => val !== null) && designRug.rugArea > 0) {
  btnSaveRug.textContent = 'Saving...';
  if (!designRug.id) {
    designRug.id = Math.random().toString(36).slice(2);
    designRug.dateAdded = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
  } else {
    const rugToRemove = savedRugs.indexOf(savedRugs.find(r => r.id === designRug.id));
    savedRugs.splice(rugToRemove, 1);
    designRug.dateModified = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
  }
  designRug.rugName = rugName.value;
  designRug.priceExpires = `${date30.getMonth() + 1}-${date30.getDate()}-${date30.getFullYear()}`;
  savedRugs.push({...designRug});
  }
  return savedRugs;
}

const rugPads = {
  591: {
      10: 1.60,
      11: 1.70,
      12: 2.25,
      name: 'Cushion Grip 591',
      img: imageFile + '591CushionGripe1623254991721.webp?v=1687206006'
  },
  592: {
      10: 2.15,
      11: 2.25,
      12: 3.00,
      name: 'Premium Grip 592',
      img: imageFile + '592PremiumGripRugPade1623255003460.webp?v=1687206006'
  },
  595: {
      10: 2.45,
      11: 2.55,
      12: 3.40,
      name: 'Attached Non-Skid 595',
      img: imageFile + '593AttachedNonSkidBackinge1623255012252.webp?v=1687206006'
  },
  594: {
      10: 1.60,
      11: 1.70,
      12: 2.25,
      name: 'Outdoor 594',
      img: imageFile + '594IndoorOutdoorRugPade1623255023127.webp?v=1687206006'
  },
  597: {
      10: 2.20,
      11: 2.30,
      12: 3.05,
      name: 'Attached Cloth 597',
      img: imageFile + 'Rug_Pads_597.jpg?v=1711560058'
  },
  598: {
      10: 2.20,
      11: 2.30,
      12: 3.05,
      name: 'Attached Felt 598',
      img: imageFile + '598AttachedFeltBackinge1623254930213.webp?v=1687206006'
  },
  1000: {
      10: 0,
      11: 0,
      12: 0,
      name: 'None',
      img: imageFile + '44476fa0-59e9-49c3-b1b2-5307294438c3.jpg?v=1707860530'
  }
}

const borderStyles = {
  Chenille: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredStandard: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        40: imageFile + 'chenille40_75fef699-82d1-4eeb-a6df-c5abc62a9e47.webp?v=1687185505',
        41: imageFile + 'chenille41_ab744d06-ad32-460e-9521-bcd3553789df.webp?v=1687185505',
        46: imageFile + 'chenille46_4121a94d-234a-4229-a90c-6a6231f07cb1.webp?v=1687185505',
        48: imageFile + 'chenille48_69bc8c97-c3b5-4309-877b-d8ce7e8137a7.webp?v=1687185503',
        50: imageFile + 'chenille50_6b9bc846-0d38-4d31-bd82-726240a1daac.webp?v=1687185503',
        51: imageFile + 'chenille51_a64ac526-48ae-405d-875d-502d11fecd7b.webp?v=1687185503',
        52: imageFile + 'chenille52_4c1cab44-fef2-42e8-938b-cd20a7d1c3de.webp?v=1687185505',
      }
    }
  },
  CheyenneLeatherRetiring: {
    Mitered: {
      price: {
        10: 145,
        11: 150,
        12: 195,
      }
    },
    MiteredStandard: {
     price: {
        10: 13.85,
        11: 14.45,
        12: 19.15,
      },
    image: {
        560: imageFile + 'cheyenne560_3ffbda25-c768-4553-94da-bbdac9fa4f42.webp?v=1687186327',
        561: imageFile + 'cheyenne561_64736f33-4001-43cd-89ed-1e7ce4378ece.webp?v=1687186328',
        562: imageFile + 'cheyenne562_21c4f633-bcca-4b88-ab65-47c66a8e4777.webp?v=1687186328',
        563: imageFile + 'cheyenn563_b319bf72-9527-4226-972e-78786bd824cb.webp?v=1687186328',
      }
    },
    SquareStandard: {
      price: {
        10: 13.85,
        11: 14.45,
        12: 19.15,
      },
      image: {
        560: imageFile + 'cheyenne-560-sq.png?v=1687380318',
        561: imageFile + 'cheyenne-561-sq.png?v=1687380319',
        562: imageFile + 'cheyenne-562-sq.png?v=1687380318',
        563: imageFile + 'cheyenn563.webp?v=1686937400'
      }
    }
  },
  Cotton: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95,
      },
      image: {
        702: imageFile + '702_wide.png?v=1686937267',
        703: imageFile + '703_wide.png?v=1686937267',
        705: imageFile + '705wide1_c6a8e554-0278-4d3d-b87c-add1fa9861bd.webp?v=1687186694',
        706: imageFile + '706wide1_5fe3cd4b-88fc-4c69-9ab8-b2fe002aa429.webp?v=1687186693',
        707: imageFile + '707wide2.webp?v=1686937402',
        709: imageFile + '709wide1_0280999a-ab0d-44fa-b729-ccd855bd7ac6.webp?v=1687186696',
        711: imageFile + '711wide1_b23527b3-4a87-4ebf-9968-4736af4d74de.webp?v=1687186692',
        713: imageFile + '713wide1_265fa4fe-17bc-44f9-b704-8049a3ef70a4.webp?v=1687186695',
        720: imageFile + '720wide1_8ff4055f-0fde-4d9d-9a1f-5cbccac67ee6.webp?v=1687186698',
        721: imageFile + '721wide1_a76c9276-c1d0-4a12-a173-ff289f324fec.webp?v=1687186699',
        722: imageFile + '722wide1_a6839d66-dd57-462c-a6a3-00f290dc5925.webp?v=1687186693',
        723: imageFile + '723wide1_00fe37b8-a32b-4664-aba6-b910f18d95e4.webp?v=1687186699',
        725: imageFile + '725wide1_8a90374d-e330-40f3-a236-362d142ff466.webp?v=1687186697',
        726: imageFile + '726wide1_d4becee1-4b4f-4468-9def-a18172a3caa7.webp?v=1687186689',
        727: imageFile + '727wide1_9f1be7c1-e0ef-42a0-82ed-b1b7cf9a7946.webp?v=1687186690',
        729: imageFile + '729wide1_4b3fec22-d520-4e14-929e-7ad31cc7f8b7.webp?v=1687186698',
        730: imageFile + '730wide1_3d4df128-5f90-4e39-b481-a58a45e372b6.webp?v=1687186696',
        731: imageFile + '731wide1_be29d222-9511-4d0d-a319-1f6fbe56b0e4.webp?v=1687186691',
        732: imageFile + '732wide1_bac94abf-8365-4d3a-9787-e9fcf6ff9b00.webp?v=1687186691',
        733: imageFile + '733wide_b359dfb6-3e32-4b38-baf3-3eae4170a3aa.webp?v=1687186689',
        734: imageFile + '734wide_cd00b314-3f42-4432-a9da-f6febb5e7c90.webp?v=1687186692',
        735: imageFile + '735Wide1_8e89c6d2-3270-45a3-9e6b-3727c7dd2603.webp?v=1687186692',
        736: imageFile + '736wide1_04bbe608-6aa8-41e0-afcf-d6aab4cc1b87.webp?v=1687186695',
        740: imageFile + '740wide1_f3b7beb3-2e9a-4798-b144-cdc26a21af46.webp?v=1687186696',
        741: imageFile + '741wide_4ff59fe3-1ed3-40e1-8615-62325fd1e899.webp?v=1687186689',
        742: imageFile + '742wide2_06113d27-6522-4ce6-99a9-3d37883ff12a.webp?v=1687186689',
        743: imageFile + '743wide1_11ff2e07-415e-4c8f-9b50-9045ef44b96a.webp?v=1687186691',
        744: imageFile + '744wide1_151e2246-f997-4e1e-9e43-8d5548cd5a89.webp?v=1687186692',
        745: imageFile + '745wide_13f0cc3c-ffc7-4f96-b691-85d0b3970823.webp?v=1687186695',
        746: imageFile + '746wide_f29e6ac2-5ea7-484e-b2cf-88786949e4f4.webp?v=1687186693',
        747: imageFile + '747wide1_6d3527c9-3a19-4507-885a-895b0ead4628.webp?v=1687186692',
        748: imageFile + '748wide1_b475fd4c-a735-4fc1-a899-36c53634b0d5.webp?v=1687186698',
        749: imageFile + '749wide1_5aea2a09-1367-4e30-9454-01e17dd561d4.webp?v=1687186691',
        750: imageFile + '750wide1_16d81a03-23da-4724-a6fe-17655bffca07.webp?v=1687186690',
        751: imageFile + '751wide1_77e54b88-d77c-4988-a76d-fe3202c5fb40.webp?v=1687186691',
        753: imageFile + '753wide1_42144ee5-a46b-49f8-82d5-4db55413db27.webp?v=1687186696',
        754: imageFile + '754wide1_d38ea277-e1c6-4652-95e8-3f8b09b68032.webp?v=1687186689',
        755: imageFile + '755_wide.png?v=1686937310',
        758: imageFile + '758wide1_8c1f67c0-7d86-459a-8f38-98fd37934049.webp?v=1687186697',
        759: imageFile + '759wide1_b09f2073-2599-4717-8e26-bae343ee46d1.webp?v=1687186690',
        776: imageFile + '776wide1_bd73645f-2bc1-497f-8c24-43df1b3f99fc.webp?v=1687186690',
        777: imageFile + '777wide1_0bd9fa21-4b93-4208-8949-a209b9006f5b.webp?v=1687186690',
        778: imageFile + '778wide1_be42ce53-e087-48fa-9702-df9f7ddb887e.webp?v=1687186690',
        779: imageFile + '779wide1_99eac7d5-2303-4a00-ba02-95a86c393991.webp?v=1687186697',
        783: imageFile + '783wide1_6cb711bd-26c0-4bf8-b887-68f97606b68e.webp?v=1687189486',
        790: imageFile + '790wide1_2cea161e-dc2c-4008-ab8d-15caa4b8b592.webp?v=1687189486',
        792: imageFile + '792SeafoamGreen.webp?v=1686937401',
      }
    },
    MiteredMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        702: imageFile + '702_medium_76c77f44-2434-4008-97bc-adae690112b7.png?v=1686937268',
        703: imageFile + '703medium.png?v=1686937267',
        705: imageFile + '705-medium.png?v=1686937266',
        706: imageFile + '706medium.png?v=1686937267',
        707: imageFile + '707medium.png?v=1686937267',
        709: imageFile + '709_medium_dd69e881-ad75-476e-98c4-7c2f45e51c18.png?v=1686937267',
        711: imageFile + '711med.png?v=1686937267',
        713: imageFile + '713-medium.png?v=1686937267',
        720: imageFile + '720_medium_75a48b7a-ba6e-4235-b8d9-c6009e786351.png?v=1686937267',
        721: imageFile + '721medium.png?v=1686937267',
        722: imageFile + '722medium.png?v=1686937267',
        723: imageFile + '723_medium_21ca8bee-d408-4dd5-8b51-d82d07f55b0d.png?v=1686937268',
        725: imageFile + '725medium.png?v=1686937267',
        726: imageFile + '726-medium.png?v=1686937268',
        727: imageFile + '727_medium_020b933c-f820-4cbc-99b0-c59a445f6092.png?v=1686937266',
        729: imageFile + '729medium.png?v=1686937267',
        730: imageFile + '730_medium_add08d22-51f8-452c-ad54-51b3e68a5d90.png?v=1686937266',
        731: imageFile + '731medium.png?v=1686937267',
        732: imageFile + '732_medium_991e9d23-3424-4a40-9a59-58f4fe6b80c4.png?v=1686937267',
        733: imageFile + '733_medium_f7d1f1bc-a610-48af-85e2-f56a85131cc9.png?v=1686937268',
        734: imageFile + '734_medium_cfd61b86-d887-4a74-98bb-8c87ca427268.png?v=1686937268',
        735: imageFile + '735_Medium_1444d070-92bb-4103-94f7-39a6b83043ea.png?v=1686937268',
        736: imageFile + '736_medium_8632bdc8-0c7c-479e-bb98-418cbb944e51.png?v=1686937268',
        740: imageFile + '740_medium_3b0a32cd-87be-437e-8d37-aaa87bec2e0f.png?v=1686937309',
        741: imageFile + '741_medium_f69d3c15-8b43-4b38-89bf-bdc72e2c3cd0.png?v=1686937309',
        742: imageFile + '742-medium.png?v=1686937309',
        743: imageFile + '743_medium_37056370-badf-408a-9938-e065a1f7ffcd.png?v=1686937310',
        744: imageFile + '744_medium_01c4e1c9-e825-4c79-8d51-703d8c6ce68f.png?v=1686937310',
        745: imageFile + '745_medium_45469a45-67ef-4569-b9f0-c17105e1efef.png?v=1686937309',
        746: imageFile + '746_med.png?v=1686937309',
        747: imageFile + '747_medium_ab4d6a8f-0fee-4149-9b5f-1c9676917cf0.png?v=1686937309',
        748: imageFile + '748_medium_d36ae83c-9c15-42ef-9e5a-06004f6fd543.png?v=1686937309',
        749: imageFile + '749-medium.png?v=1686937309',
        750: imageFile + '750_medium_c632a15d-71ee-446a-abed-58c2f1632af9.png?v=1686937309',
        751: imageFile + '751-medium.png?v=1686937309',
        753: imageFile + '753med.png?v=1686937309',
        754: imageFile + '754_medium_61239455-81e9-4290-8ea1-182990fd7e34.png?v=1686937310',
        755: imageFile + '755_med.png?v=1686937310',
        758: imageFile + '758_medium_aaf6241d-2fdd-4850-8a6f-0b71daf58a61.png?v=1686937310',
        759: imageFile + '759_medium_16ff5098-2a0b-4b5a-8357-80e36dbed246.png?v=1686937309',
        776: imageFile + '776_medium_f6f29752-fae8-42a5-927c-504eeddcf59b.png?v=1686937310',
        777: imageFile + '777_med.png?v=1686937310',
        778: imageFile + '778_med.png?v=1686937310',
        779: imageFile + '779_medium_86773bf2-2c33-4235-aa92-8eba014c6c33.png?v=1686937310',
        783: imageFile + '783_med.png?v=1686937310',
        790: imageFile + '790med.png?v=1686937311',
        792: imageFile + '792SeafoamGreen.webp?v=1686937401',
      }
    },
    SquareWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95, 
      },
      image: {
        702: imageFile + '702_wide_SQ.png?v=1686937267',
        703: imageFile + '703_wide_SQ.png?v=1686937267',
        705: imageFile + '705-wide-SQ.png?v=1686937267',
        706: imageFile + '706_wide_SQ.png?v=1686937268',
        707: imageFile + '707_wide_SQ.png?v=1686937268',
        709: imageFile + '709_wideSQ.png?v=1686937267',
        711: imageFile + '711_wide_SQ.png?v=1686937267',
        713: imageFile + '713-wide-SQ.png?v=1686937268',
        720: imageFile + '720_wide_SQ.png?v=1686937267',
        721: imageFile + '721_wide_SQ.png?v=1686937267',
        722: imageFile + '722-wide-SQ.png?v=1686937267',
        723: imageFile + '723_wide_SQ.png?v=1686937268',
        725: imageFile + '725_wide_SQ.png?v=1686937268',
        726: imageFile + '726-wide-SQ.png?v=1686937268',
        727: imageFile + '727_wide_SQ.png?v=1686937267',
        729: imageFile + '729_wide_SQ.png?v=1686937268',
        730: imageFile + '730_wide_SQ.png?v=1686937267',
        731: imageFile + '731_wide_SQ.png?v=1686937267',
        732: imageFile + '732_wide_SQ.png?v=1686937268',
        733: imageFile + '733_wide_SQ.png?v=1686937268',
        734: imageFile + '734_wide_sq.png?v=1686937268',
        735: imageFile + '735_Wide_SQ.png?v=1686937268',
        736: imageFile + '736_wide_SQ.png?v=1686937268',
        740: imageFile + '740_wide_SQ.png?v=1686937310',
        741: imageFile + '741_wide_SQ.png?v=1686937310',
        742: imageFile + '742-wide-SQ.png?v=1686937310',
        743: imageFile + '743_wide_SQ.png?v=1686937310',
        744: imageFile + '744_wide_SQ.png?v=1686937310',
        745: imageFile + '745_wide_SQ.png?v=1686937310',
        746: imageFile + '746_wide_SQ.png?v=1686937310',
        747: imageFile + '747_wide_SQ.png?v=1686937310',
        748: imageFile + '748_wide_SQ.png?v=1686937310',
        749: imageFile + '749-wide-SQ.png?v=1686937310',
        750: imageFile + '750_wide_SQ.png?v=1686937310',
        751: imageFile + '751-wide-SQ.png?v=1686937310',
        753: imageFile + '753_wide_SQ.png?v=1686937310',
        754: imageFile + '754_wide_SQ.png?v=1686937310',
        755: imageFile + '755_wide_SQ.png?v=1686937310',
        758: imageFile + '758_wide_SQ.png?v=1686937310',
        759: imageFile + '759_wide_SQ.png?v=1686937310',
        776: imageFile + '776_wide_SQ.png?v=1686937311',
        777: imageFile + '777_wide_SQ.png?v=1686937311',
        778: imageFile + '778_wide_SQ.png?v=1686937311',
        779: imageFile + '779_wide_SQ.png?v=1686937311',
        783: imageFile + '783_wide_SQ.png?v=1686937311',
        790: imageFile + '790_wide_SQ.png?v=1686937311',
        792: imageFile + '792-Seafoam-Green-SQ.png?v=1686937310',
      }
    },
    SquareMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        702: imageFile + '702mediumSQ.png?v=1686937268',
        703: imageFile + '703mediumSQ.png?v=1686937267',
        705: imageFile + '705-mediumSQ.png?v=1686937266',
        706: imageFile + '706mediumSQ.png?v=1686937267',
        707: imageFile + '707mediumSQ.png?v=1686937267',
        709: imageFile + '709_medium_SQ.png?v=1686937267',
        711: imageFile + '711mediumSQ.png?v=1686937267',
        713: imageFile + '713-mediumSQ.png?v=1686937267',
        720: imageFile + '720mediumSQ.png?v=1686937266',
        721: imageFile + '721mediumSQ.png?v=1686937267',
        722: imageFile + '722mediumSQ.png?v=1686937267',
        723: imageFile + '723_medium_SQ.png?v=1686937267',
        725: imageFile + '725mediumSQ.png?v=1686937267',
        726: imageFile + '726-medium-SQ.png?v=1686937267',
        727: imageFile + '727medSQ.png?v=1686937266',
        729: imageFile + '729mediumSQ.png?v=1686937267',
        730: imageFile + '730mediumSQ.png?v=1686937266',
        731: imageFile + '731medSQ.png?v=1686937267',
        732: imageFile + '732_med_SQ.png?v=1686937267',
        733: imageFile + '733_med_SQ.png?v=1686937268',
        734: imageFile + '734_medium_sq.png?v=1686937268',
        735: imageFile + '735_Medium_SQ.png?v=1686937268',
        736: imageFile + '736_medium_SQ.png?v=1686937268',
        740: imageFile + '740_medium_SQ.png?v=1686937309',
        741: imageFile + '741_medium_SQ.png?v=1686937309',
        742: imageFile + '742-medium-SQ.png?v=1686937309',
        743: imageFile + '743_medium_SQ.png?v=1686937309',
        744: imageFile + '744_medium_SQ.png?v=1686937310',
        745: imageFile + '745_medium_SQ.png?v=1686937309',
        746: imageFile + '746medSQ.png?v=1686937310',
        747: imageFile + '747_medium_SQ.png?v=1686937310',
        748: imageFile + '748_medium_SQ.png?v=1686937309',
        749: imageFile + '749-medium-SQ.png?v=1686937309',
        750: imageFile + '750_mediumSQ.png?v=1686937310',
        751: imageFile + '751medium-SQ.png?v=1686937310',
        753: imageFile + '753medSQ.png?v=1686937309',
        754: imageFile + '754mediumSQ.png?v=1686937310',
        755: imageFile + '755medSQ.png?v=1686937310',
        758: imageFile + '758_medium_SQ.png?v=1686937310',
        759: imageFile + '759_medium_SQ.png?v=1686937310',
        776: imageFile + '776_medium_SQ.png?v=1686937310',
        777: imageFile + '777_med_SQ.png?v=1686937310',
        778: imageFile + '778medSQ.png?v=1686937310',
        779: imageFile + '779mediumSQ.png?v=1686937310',
        783: imageFile + '783medSQ.png?v=1686937310',
        790: imageFile + '790med_SQ.png?v=1686937310',
        792: imageFile + '792-Seafoam-Green-SQ.png?v=1686937310',
      }
    },
    SquareNarrow: {
      price: {
        10: 5,
        11: 5.25,
        12: 6.95,
      },
      image: {
        702: imageFile + '702_narrow.png?v=1686937267',
        703: imageFile + '703_narrow.png?v=1686937266',
        705: imageFile + '705-narrow.png?v=1686937265',
        706: imageFile + '706_narrow.png?v=1686937266',
        707: imageFile + '707narrow.png?v=1686937267',
        709: imageFile + '709_narrow.png?v=1686937266',
        711: imageFile + '711Narrow.png?v=1686937266',
        713: imageFile + '713-narrow.png?v=1686937266',
        720: imageFile + '720_narrow.png?v=1686937266',
        721: imageFile + '721_narrow.png?v=1686937266',
        722: imageFile + '722-narrow.png?v=1686937266',
        723: imageFile + '723_narrow.png?v=1686937267',
        725: imageFile + '725_narrow.png?v=1686937266',
        726: imageFile + '726-narrow.png?v=1686937267',
        727: imageFile + '727narrow.png?v=1686937266',
        729: imageFile + '729narrow.png?v=1686937266',
        730: imageFile + '730_narrow.png?v=1686937266',
        731: imageFile + '731narrow.png?v=1686937266',
        732: imageFile + '732_narrow.png?v=1686937267',
        733: imageFile + '733_narrow.png?v=1686937267',
        734: imageFile + '734_narrow.png?v=1686937267',
        735: imageFile + '735_narrow.png?v=1686937268',
        736: imageFile + '736_narrow.png?v=1686937268',
        740: imageFile + '740_narrow.png?v=1686937308',
        741: imageFile + '741_narrow.png?v=1686937309',
        742: imageFile + '742-narrow.png?v=1686937308',
        743: imageFile + '743_narrow.png?v=1686937308',
        744: imageFile + '744_narrow.png?v=1686937308',
        745: imageFile + '745_narrow.png?v=1686937308',
        746: imageFile + '746_narrow.png?v=1686937309',
        747: imageFile + '747_narrow.png?v=1686937309',
        748: imageFile + '748_narrow.png?v=1686937309',
        749: imageFile + '749-narrow.png?v=1686937308',
        750: imageFile + '750_narrow.png?v=1686937309',
        751: imageFile + '751narrow.png?v=1686937309',
        753: imageFile + '753_narrow.png?v=1686937309',
        754: imageFile + '754_narrow.png?v=1686937309',
        755: imageFile + '755_narrow.png?v=1686937309',
        758: imageFile + '758_narrow.png?v=1686937309',
        759: imageFile + '759_narrow.png?v=1686937309',
        776: imageFile + '776_narrow.png?v=1686937309',
        777: imageFile + '777_narrow.png?v=1686937310',
        778: imageFile + '778_narrow.png?v=1686937310',
        779: imageFile + '779_narrow.png?v=1686937310',
        783: imageFile + '783_narrow.png?v=1686937311',
        790: imageFile + '790_narrow.png?v=1686937310',
        792: imageFile + '792-Seafoam-Green-SQ.png?v=1686937310',
      }
    },
    SquareMediumVisible: {
      price: {
        10: 5.8,
        11: 6.1,
        12: 8.05,
      },
      image: {
        702: imageFile + '702mediumSQ.png?v=1686937268',
        703: imageFile + '703mediumSQ.png?v=1686937267',
        705: imageFile + '705-mediumSQ.png?v=1686937266',
        706: imageFile + '706mediumSQ.png?v=1686937267',
        707: imageFile + '707mediumSQ.png?v=1686937267',
        709: imageFile + '709_medium_SQ.png?v=1686937267',
        711: imageFile + '711mediumSQ.png?v=1686937267',
        713: imageFile + '713-mediumSQ.png?v=1686937267',
        720: imageFile + '720mediumSQ.png?v=1686937266',
        721: imageFile + '721mediumSQ.png?v=1686937267',
        722: imageFile + '722mediumSQ.png?v=1686937267',
        723: imageFile + '723_medium_SQ.png?v=1686937267',
        725: imageFile + '725mediumSQ.png?v=1686937267',
        726: imageFile + '726-medium-SQ.png?v=1686937267',
        727: imageFile + '727medSQ.png?v=1686937266',
        729: imageFile + '729mediumSQ.png?v=1686937267',
        730: imageFile + '730mediumSQ.png?v=1686937266',
        731: imageFile + '731medSQ.png?v=1686937267',
        732: imageFile + '732_med_SQ.png?v=1686937267',
        733: imageFile + '733_med_SQ.png?v=1686937268',
        734: imageFile + '734_medium_sq.png?v=1686937268',
        735: imageFile + '735_Medium_SQ.png?v=1686937268',
        736: imageFile + '736_medium_SQ.png?v=1686937268',
        740: imageFile + '740_medium_SQ.png?v=1686937309',
        741: imageFile + '741_medium_SQ.png?v=1686937309',
        742: imageFile + '742-medium-SQ.png?v=1686937309',
        743: imageFile + '743_medium_SQ.png?v=1686937309',
        744: imageFile + '744_medium_SQ.png?v=1686937310',
        745: imageFile + '745_medium_SQ.png?v=1686937309',
        746: imageFile + '746medSQ.png?v=1686937310',
        747: imageFile + '747_medium_SQ.png?v=1686937310',
        748: imageFile + '748_medium_SQ.png?v=1686937309',
        749: imageFile + '749-medium-SQ.png?v=1686937309',
        750: imageFile + '750_mediumSQ.png?v=1686937310',
        751: imageFile + '751medium-SQ.png?v=1686937310',
        753: imageFile + '753medSQ.png?v=1686937309',
        754: imageFile + '754mediumSQ.png?v=1686937310',
        755: imageFile + '755medSQ.png?v=1686937310',
        758: imageFile + '758_medium_SQ.png?v=1686937310',
        759: imageFile + '759_medium_SQ.png?v=1686937310',
        776: imageFile + '776_medium_SQ.png?v=1686937310',
        777: imageFile + '777_med_SQ.png?v=1686937310',
        778: imageFile + '778medSQ.png?v=1686937310',
        779: imageFile + '779mediumSQ.png?v=1686937310',
        783: imageFile + '783medSQ.png?v=1686937310',
        790: imageFile + '790med_SQ.png?v=1686937310',
        792: imageFile + '792-Seafoam-Green-SQ.png?v=1686937310',
      }
    }
  },
  DistressedLeather: {
    Mitered: {
      price: {
        10: 145,
        11: 150,
        12: 195,
      }
    },
    MiteredStandard: {
      price: {
        10: 23.45,
        11: 24.45,
        12: 32.35,
      },
      image: {
        590: imageFile + 'Distressed_Leather_590.png?v=1686937349',
        591: imageFile + 'Distressed_Leather_591.png?v=1686937349',
        592: imageFile + 'Distressed_Leather_592.png?v=1686937349',
        593: imageFile + 'Distressed_Leather_593.png?v=1686937350',
        594: imageFile + 'distressed_leather_594.png?v=1686937349',
        595: imageFile + 'distressed_leather_595.png?v=1686937349',
        596: imageFile + 'distressed_leather_596.png?v=1686937349',
        597: imageFile + 'distressedleather597_c9c8b1bc-1686-4dd7-bd29-491071ab3a1a.webp?v=1687191069',
        598: imageFile + 'distressed-leather-598-sq.png?v=1687271890',
        599: imageFile + 'distressed-leather-599-SQ.png?v=1687271891',
      }
    },
    SquareStandard: {
      price: {
        10: 23.45,
        11: 24.45,
        12: 32.35,
      },
      image: {
        590: imageFile + 'Distressed_Leather_590_SQ.png?v=1686937349',
        591: imageFile + 'Distressed_Leather_591_SQ.png?v=1686937349',
        592: imageFile + 'Distressed_Leather_592_SQ.png?v=1686937349',
        593: imageFile + 'Distressed_Leather_593_SQ.png?v=1686937349',
        594: imageFile + 'distressed_leather_594_SQ.png?v=1686937349',
        595: imageFile + 'distressed_leather_595_SQ.png?v=1686937350',
        596: imageFile + 'distressed_leather_596_SQ.png?v=1686937349',
        597: imageFile + 'distressed-leather-597-sq.png?v=1687271890',
        598: imageFile + 'distressed-leather-598-sq.png?v=1687271890',
        599: imageFile + 'distressed-leather-599-SQ.png?v=1687271891',
      }
    }
  },
  Jute: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95,
      },
      image: {
        205: imageFile + 'Jute_205_wide.png?v=1686937350',
        231: imageFile + 'jute231medium.webp?v=1686937401',
      }
    },
    MiteredMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        205: imageFile + 'Jute_205_medium_2418c774-5f8e-4a56-8a4d-9b982cffb4f1.png?v=1686937350',
        231: imageFile + 'jute231medium.webp?v=1686937401',
      }
    },
    SquareWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95,
      },
      image: {
        205: imageFile + 'Jute_205_wide_SQ.png?v=1686937350',
        231: imageFile + 'jute-231-medium-sq.png?v=1687277758',
      }
    },
    SquareMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        205: imageFile + 'Jute_205_medium_SQ.png?v=1686937350',
        231: imageFile + 'jute-231-medium-sq.png?v=1687277758',
      }
    },
    SquareMediumVisible: {
      price: {
        10: 5.8,
        11: 6.1,
        12: 8.05,
      },
      image: {
        205: imageFile + 'Jute_205_medium_SQ.png?v=1686937350',
        231: imageFile + 'jute-231-medium-sq.png?v=1687277758',
      }
    },
    SquareNarrow: {
      price: {
        10: 5,
        11: 5.25,
        12: 6.95,
      },
      image: {
        205: imageFile + 'Jute_205_narrow.png?v=1686937349',
        231: imageFile + 'jute-231-narrow.png?v=1687281104',
      }
    }
  },
   JuteBraid: {
     Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
     SquareStandard: {
       price: {
        10: 15.8,
        11: 16.5,
        12: 21.85,
       },
       image: {
        270: imageFile + 'jute_braid_270.png?v=1686937350',
        271: imageFile + 'jute_braid_271.png?v=1686937350',
        2892: imageFile + 'jute_braid_2892.png?v=1686937351',
        2893: imageFile + 'jute_braid_2893.png?v=1686937351',
        2894: imageFile + 'jute_braid_2894.png?v=1686937351',
        2895: imageFile + 'jute_braid_2895.png?v=1686937351',
        2896: imageFile + 'jute_braid_2896.png?v=1686937351',
        2897: imageFile + 'jute_braid_2897.png?v=1686937350',
       }
     },
     MiteredStandard: {
       price: {
        10: 15.8,
        11: 16.5,
        12: 21.85,
       },
       image: {
        270: imageFile + 'Mitered-Corner-270.png?v=1709069466',
        271: imageFile + '271.png?v=1709069466',
        2892: imageFile + 'Mitered-Corner_2892.png?v=1709069465',
        2893: imageFile + 'Mitered-Corner_2893.png?v=1709069466',
        2894: imageFile + '2894.png?v=1709069466',
        2895: imageFile + 'Mitered-Corner_2895.png?v=1709069465',
        2896: imageFile + 'Mitered-Corner_2896.png?v=1709069466',
        2897: imageFile + 'Mitered-Corner_2897.png?v=1709069465',
       }
     }
   },
  JuteChenille: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95,
      },
      image: {
        2000: imageFile + 'Jute-Chenille-2000.png?v=1686937350',
        2001: imageFile + 'Jute-Chenille-2001.png?v=1686937350',
        2002: imageFile + 'Jute-Chenille-2002.png?v=1686937350',
        2003: imageFile + 'Jute-Chenille-2003.png?v=1686937350',
        2004: imageFile + 'Jute-Chenille-2004.png?v=1686937350',
      }
    },
    MiteredMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        2000: imageFile + 'Jute-Chenille-2000-MED.png?v=1686937350',
        2001: imageFile + 'Jute-Chenille-2001-MED.png?v=1686937350',
        2002: imageFile + 'Jute-Chenille-2002-MED.png?v=1686937350',
        2003: imageFile + 'Jute-Chenille-2003-MED.png?v=1686937349',
        2004: imageFile + 'Jute-Chenille-2004-MED.png?v=1686937349',
      }
    },
    SquareWide: {
      price: {
        10: 8.65,
        11: 9.05,
        12: 11.95,
      },
      image: {
        2000: imageFile + 'Jute-Chenille-2000-SQ.png?v=1686937351',
        2001: imageFile + 'Jute-Chenille-2001-SQ.png?v=1686937350',
        2002: imageFile + 'Jute-Chenille-2002-SQ.png?v=1686937350',
        2003: imageFile + 'Jute-Chenille-2003-SQ.png?v=1686937349',
        2004: imageFile + 'Jute-Chenille-2004-SQ.png?v=1686937349',
      }
    },
    SquareMediumInvisible: {
      price: {
        10: 6.75,
        11: 7,
        12: 9.3,
      },
      image: {
        2000: imageFile + 'Jute-Chenille-2000-MED-SQ.png?v=1686937349',
        2001: imageFile + 'Jute-Chenille-2001-MED-SQ.png?v=1686937349',
        2002: imageFile + 'Jute-Chenille-2002-MED-SQ.png?v=1686937350',
        2003: imageFile + 'Jute-Chenille-2003-MED-SQ.png?v=1686937349',
        2004: imageFile + 'Jute-Chenille-2004-MED-SQ.png?v=1686937349',
      }
    },
  },
  Linen: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredWide: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        671: imageFile + 'linen_671.png?v=1686937350',
        672: imageFile + 'Linen_672.png?v=1686937349',
        674: imageFile + 'Linen_674.png?v=1686937349',
        676: imageFile + 'linen676_90734a4f-f54f-4536-97ac-3d1594226181.webp?v=1687192438',
        680: imageFile + 'Linen680_5d07cc1f-6971-452f-8086-c8b9b309f6dc.webp?v=1687192437',
        681: imageFile + 'Linen_681.png?v=1686937350',
        682: imageFile + 'Linen_682.png?v=1686937350',
        683: imageFile + 'Linen_683.png?v=1686937350',
        684: imageFile + 'Linen_684.png?v=1686937350',
        685: imageFile + 'linen_685.png?v=1686937350',
        686: imageFile + 'linen_686.png?v=1686937350',
        688: imageFile + 'Linen_688.png?v=1686937351',
        689: imageFile + 'Linen_689.png?v=1686937351',
        690: imageFile + 'Linen-690.png?v=1686937352',
        691: imageFile + 'Linen-691.png?v=1686937352',
        692: imageFile + 'Linen-692.png?v=1686937351',
        693: imageFile + 'Linen-693.png?v=1686937352',
        694: imageFile + 'Linen-694.png?v=1686937352',
        695: imageFile + 'Linen-695.png?v=1686937353',
        696: imageFile + 'Linen_696.png?v=1686937351',
        697: imageFile + 'Linen-697.png?v=1686937352',
        698: imageFile + 'Linen_698.png?v=1686937350',
        699: imageFile + 'Linen_699.png?v=1686937350',
      }
    },
    SquareWide: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        671: imageFile + 'linen_671_SQ.png?v=1686937350',
        672: imageFile + 'Linen_672_SQ.png?v=1686937349',
        674: imageFile + 'Linen_674_SQ.png?v=1686937350',
        676: imageFile + 'linen-676-sq.png?v=1687283271',
        680: imageFile + 'linen-680-sq.png?v=1687283586',
        681: imageFile + 'Linen-681-SQ.png?v=1687283587',
        682: imageFile + 'Linen-682-SQ-1.png?v=1687283586',
        683: imageFile + 'Linen-683-SQ.png?v=1687283587',
        684: imageFile + 'Linen-684-SQ.png?v=1687283587',
        685: imageFile + 'linen-685-SQ.png?v=1687283586',
        686: imageFile + 'linen_686_SQ.png?v=1686937350',
        688: imageFile + 'Linen-688-SQ-1.png?v=1687373952',
        689: imageFile + 'Linen_689_SQ.png?v=1686937351',
        690: imageFile + 'Linen-690-SQ.png?v=1686937352',
        691: imageFile + 'Linen-691-SQ.png?v=1686937352',
        692: imageFile + 'Linen-692-SQ.png?v=1686937352',
        693: imageFile + 'Linen_693_SQ.png?v=1686937350',
        694: imageFile + 'Linen-694-SQ.png?v=1686937352',
        695: imageFile + 'Linen-695-SQ.png?v=1686937353',
        696: imageFile + 'Linen_696_SQ.png?v=1686937351',
        697: imageFile + 'Linen-697-SQ.png?v=1686937352',
        698: imageFile + 'Linen_698_SQ.png?v=1686937350',
        699: imageFile + 'Linen_699_SQ.png?v=1686937350',
      }
    }
  },
  RecycledLeather: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredStandard: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        630: imageFile + 'Recycled_Leather_630.png?v=1686937352',
        631: imageFile + 'Recycled_Leather_631.png?v=1686937352',
        632: imageFile + 'Recycled_Leather_632.png?v=1686937352',
        633: imageFile + 'Recycled_Leather_633.png?v=1686937352',
        634: imageFile + 'Recycled-Leather-634.png?v=1686937353',
        635: imageFile + 'Recycled_Leather_635.png?v=1686937352',
        636: imageFile + 'Recycled_Leather_636.png?v=1686937352',
        637: imageFile + 'Recycled-Leather-637.png?v=1686937352',
        638: imageFile + 'Recycled-Leather-638.png?v=1686937352',
        639: imageFile + 'Recycled-Leather-639.png?v=1686937352',
      }
    },
    SquareStandard: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        630: imageFile + 'Recycled_Leather_630_SQ.png?v=1686937352',
        631: imageFile + 'Recycled_Leather_631_SQ.png?v=1686937352',
        632: imageFile + 'Recycled_Leather_632_SQ.png?v=1686937352',
        633: imageFile + 'Recycled_Leather_633_SQ.png?v=1686937352',
        634: imageFile + 'Recycled-Leather-634-SQ.png?v=1686937352',
        635: imageFile + 'Recycled_Leather_635_SQ.png?v=1686937352',
        636: imageFile + 'Recycled_Leather_636_SQ.png?v=1686937352',
        637: imageFile + 'Recycled-Leather-637-SQ.png?v=1686937352',
        638: imageFile + 'Recycled-Leather-638-SQ.png?v=1686937352',
        639: imageFile + 'Recycled-Leather-639-SQ.png?v=1686937352',
      }
    }
  },
  SmoothLeather: {
    Mitered: {
      price: {
        10: 145,
        11: 150,
        12: 195,
      }
    },
    MiteredStandard: {
      price: {
        10: 15.75,
        11: 16.45,
        12: 21.8,
      },
      image: {
        600: imageFile + 'Smooth_Leather_600_Brown.png?v=1686937351',
        601: imageFile + 'Smooth_Leather_601.png?v=1686937352',
        602: imageFile + 'Smooth_Leather_602.png?v=1686937352',
        603: imageFile + 'smoothleather603_f4ddc502-b510-4a45-bdb0-c4d5e616f951.webp?v=1687193617',
        604: imageFile + 'Smooth_Leather_604.png?v=1686937352',
        605: imageFile + 'smooth_leather_605.png?v=1686937352',
        606: imageFile + 'smoothleather606_bd594d46-d5d6-4c38-810e-1293ff4175bd.webp?v=1687193617',
        607: imageFile + 'Smooth_Leather_607.png?v=1686937352',
        608: imageFile + 'smooth_leather_608.png?v=1686937353',
        609: imageFile + 'smooth_leather_609.png?v=1686937352',
      }
    },
    SquareStandard: {
      price: {
        10: 15.75,
        11: 16.45,
        12: 21.8,
      },
      image: {
        600: imageFile + 'Smooth_Leather_600_Brown_SQ.png?v=1686937352',
        601: imageFile + 'Smooth_Leather_601_SQ.png?v=1686937351',
        602: imageFile + 'Smooth_Leather_602_SQ.png?v=1686937352',
        603: imageFile + 'smooth-leather-603-sq.png?v=1687286268',
        604: imageFile + 'Smooth_Leather_604_SQ.png?v=1686937352',
        605: imageFile + 'smooth_leather_605_SQ.png?v=1686937352',
        606: imageFile + 'smooth-leather-606-sq.png?v=1687286420',
        607: imageFile + 'Smooth_Leather_607_SQ.png?v=1686937352',
        608: imageFile + 'smooth_leather_608_SQ.png?v=1686937352',
        609: imageFile + 'smooth_leather_609_SQ.png?v=1686937352',
      }
    }
  },
  TexturedLeather: {
    Mitered: {
      price: {
        10: 145,
        11: 150,
        12: 195,
      }
    },
    MiteredStandard: {
      price: {
        10: 15.75,
        11: 16.45,
        12: 21.8,
      },
      image: {
        610: imageFile + 'Textured_Leather_610.png?v=1686937352',
        611: imageFile + 'textured_leather_611.png?v=1686937352',
        614: imageFile + 'textured_leather_614.png?v=1686937352',
        615: imageFile + 'textured_leather_615.png?v=1686937352',
        616: imageFile + 'texturedleather616_6bc48b44-4ec6-45fe-8b21-58a98bcb3063.webp?v=1687193904',
        617: imageFile + 'Textured_Leather_617.png?v=1686937352',
        618: imageFile + 'Textured_Leather_618.png?v=1686937353',
        620: imageFile + 'textured_leather_620.png?v=1686937353',
        621: imageFile + 'textured_leather_621.png?v=1686937352',
        623: imageFile + 'texturedleather623_f8cd74b9-01e7-4b0f-adb7-c66b359303b3.webp?v=1687193904',
      }
    },
    SquareStandard: {
      price: {
        10: 15.75,
        11: 16.45,
        12: 21.8,
      },
      image: {
        610: imageFile + 'Textured_Leather_610_SQ.png?v=1686937352',
        611: imageFile + 'textured_leather_611_SQ.png?v=1686937352',
        614: imageFile + 'textured_leather_614_SQ.png?v=1686937352',
        615: imageFile + 'textured_leather_615_SQ.png?v=1686937352',
        616: imageFile + 'textured-leather-616-sq.png?v=1687287172',
        617: imageFile + 'Textured_Leather_617_SQ.png?v=1686937353',
        618: imageFile + 'Textured_Leather_618_SQ.png?v=1686937352',
        620: imageFile + 'textured_leather_620_SQ.png?v=1686937352',
        621: imageFile + 'textured_leather_621_SQ.png?v=1686937353',
        623: imageFile + 'textured-leather-623-sq.png?v=1687287323',
      }
    } 
  },
  WovenOutdoor: {
    VisibleMiteredStandard: {
      price: {
        10: 5.8,
        11: 6.1,
        12: 8.05,
      },
      image: {
        1470: imageFile + 'Woven-Outdoor-Borders_1470_5b35eccc-8bc4-4b0b-bca3-956a8816f0ec.png?v=1687194207',
        1471: imageFile + 'Woven-Outdoor-Borders_1471_1398eef8-de89-47bf-970e-c7f1648374e7.png?v=1687194208',
        1472: imageFile + 'Woven-Outdoor-Borders_1472_031faccb-2519-4b68-bf99-63de29553475.png?v=1687194207',
        1473: imageFile + 'Woven-Outdoor-Borders_1473_ff4f0363-1d5c-4bfd-8185-101d53a3ee30.png?v=1687194207',
      }
    }
  },
  WovenTapestry: {
    Mitered: {
      price: {
        10: 110,
        11: 115,
        12: 155,
      }
    },
    MiteredStandard: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        80: imageFile + 'woventapestry80_0e0fa564-fd2f-484e-979a-08d4adf94668.webp?v=1687194405',
        105: imageFile + 'woventapestry105_e6ede473-704c-4fa3-b31a-8ecffe22ce21.webp?v=1687194406',
        109: imageFile + 'woventapestry109_01c8cb63-e1e4-44c6-b39b-de6aa33a7e74.webp?v=1687194405',
        112: imageFile + 'WovenTapestry112_3cf55f24-c542-4bf7-96e8-1103afccaa9d.webp?v=1687194405',
        114: imageFile + 'woventapestry114_6ef33a31-7562-41cf-abcf-311c9c03122b.webp?v=1687194406',
        119: imageFile + 'woventapestry119_314362a9-5ad4-43b4-9007-ef0271c757ed.webp?v=1687194407',
        130: imageFile + 'WovenTapestry130_5fff4d69-677f-4d30-859f-99c262a7f990.webp?v=1687194403',
        131: imageFile + 'WovenTapestry131_f0401249-e3e6-471d-8434-6303e0085bd4.webp?v=1687194404',
        133: imageFile + 'woventapestry133_a5427de9-e0a3-46f3-8431-65521b841b9a.webp?v=1687194408',
        134: imageFile + 'WovenTapestry134_090981ec-b101-49ef-aaf7-76bae6990215.webp?v=1687194404',
        135: imageFile + 'WovenTapestry135_60cf2c92-ab73-4fff-bb8e-49a761a86f3a.webp?v=1687194410',
        141: imageFile + 'WovenTapestry141_1eca974b-3f22-44b6-bddc-59121ae010e3.webp?v=1687194412',
        142: imageFile + 'WovenTapestry142_76748d83-5ec3-4af1-886a-e64011303ec6.webp?v=1687194407',
        150: imageFile + 'woventapestry150_07f963e4-d328-4a21-98c5-7ec47d2d0880.webp?v=1687194404',
        151: imageFile + 'woventapestry151_abe77b5d-03fd-4758-8439-d31a94b644ef.webp?v=1687194411',
        152: imageFile + 'WovenTapestry1521_93665e32-d48b-42d3-a81d-4e37446c7c2c.webp?v=1687194410',
        153: imageFile + 'WovenTapestry153_16061bfa-b2c9-4c2f-bb43-8b271486696d.webp?v=1687194409',
        154: imageFile + 'woventapestry154_8bd80601-6f7c-42eb-9d5e-f2a0f6338764.webp?v=1687194410',
        157: imageFile + 'WovenTapestry157_9bd13029-5158-43b5-9b54-181a2703b8e7.webp?v=1687194410',
        158: imageFile + 'WovenTapestry158_c0e85366-1b05-44a4-98d3-9a8afdfe4b56.webp?v=1687194410',
        171: imageFile + 'WovenTapestry171_9cf40058-50f1-4bee-81c6-341167eac12f.webp?v=1687194411',
        172: imageFile + 'woventapestry172_7cab299c-1f11-47ac-b1fe-566ed0869e32.webp?v=1687194406',
        173: imageFile + 'woventapestry173_555e0083-7d60-4dc2-bc1e-3200d8cdd20b.webp?v=1687194412',
        174: imageFile + 'woventapestry174_5275dede-9cc7-4c6b-9170-eb09aff04ef2.webp?v=1687194404',
        175: imageFile + 'WovenTapestry175_fa1c199d-7d0f-4da4-92bb-09516f7f3152.webp?v=1687194411',
        184: imageFile + 'WovenTapestry184_fa3f1a58-ff98-4c93-8273-ad691be6c865.webp?v=1687194406',
        185: imageFile + 'WovenTapestry185_c2b2b4c2-a18e-425e-8dad-90361041fc92.webp?v=1687194411',
        186: imageFile + 'woventapestry186_d32d6d3f-d9a1-493d-9532-01e7b1f0930c.webp?v=1687194406',
      }
    },
    SquareStandard: {
      price: {
        10: 12.8,
        11: 13.4,
        12: 17.7,
      },
      image: {
        80: imageFile + 'woventapestry80_0e0fa564-fd2f-484e-979a-08d4adf94668.webp?v=1687194405',
        105: imageFile + 'woventapestry105_e6ede473-704c-4fa3-b31a-8ecffe22ce21.webp?v=1687194406',
        109: imageFile + 'woventapestry109_01c8cb63-e1e4-44c6-b39b-de6aa33a7e74.webp?v=1687194405',
        112: imageFile + 'WovenTapestry112_3cf55f24-c542-4bf7-96e8-1103afccaa9d.webp?v=1687194405',
        114: imageFile + 'woventapestry114_6ef33a31-7562-41cf-abcf-311c9c03122b.webp?v=1687194406',
        119: imageFile + 'woventapestry119_314362a9-5ad4-43b4-9007-ef0271c757ed.webp?v=1687194407',
        130: imageFile + 'WovenTapestry130_5fff4d69-677f-4d30-859f-99c262a7f990.webp?v=1687194403',
        131: imageFile + 'WovenTapestry131_f0401249-e3e6-471d-8434-6303e0085bd4.webp?v=1687194404',
        133: imageFile + 'woventapestry133_a5427de9-e0a3-46f3-8431-65521b841b9a.webp?v=1687194408',
        134: imageFile + 'WovenTapestry134_090981ec-b101-49ef-aaf7-76bae6990215.webp?v=1687194404',
        135: imageFile + 'WovenTapestry135_60cf2c92-ab73-4fff-bb8e-49a761a86f3a.webp?v=1687194410',
        141: imageFile + 'WovenTapestry141_1eca974b-3f22-44b6-bddc-59121ae010e3.webp?v=1687194412',
        142: imageFile + 'WovenTapestry142_76748d83-5ec3-4af1-886a-e64011303ec6.webp?v=1687194407',
        150: imageFile + 'woventapestry150_07f963e4-d328-4a21-98c5-7ec47d2d0880.webp?v=1687194404',
        151: imageFile + 'woventapestry151_abe77b5d-03fd-4758-8439-d31a94b644ef.webp?v=1687194411',
        152: imageFile + 'WovenTapestry1521_93665e32-d48b-42d3-a81d-4e37446c7c2c.webp?v=1687194410',
        153: imageFile + 'WovenTapestry153_16061bfa-b2c9-4c2f-bb43-8b271486696d.webp?v=1687194409',
        154: imageFile + 'woventapestry154_8bd80601-6f7c-42eb-9d5e-f2a0f6338764.webp?v=1687194410',
        157: imageFile + 'WovenTapestry157_9bd13029-5158-43b5-9b54-181a2703b8e7.webp?v=1687194410',
        158: imageFile + 'WovenTapestry158_c0e85366-1b05-44a4-98d3-9a8afdfe4b56.webp?v=1687194410',
        171: imageFile + 'WovenTapestry171_9cf40058-50f1-4bee-81c6-341167eac12f.webp?v=1687194411',
        172: imageFile + 'woventapestry172_7cab299c-1f11-47ac-b1fe-566ed0869e32.webp?v=1687194406',
        173: imageFile + 'woventapestry173_555e0083-7d60-4dc2-bc1e-3200d8cdd20b.webp?v=1687194412',
        174: imageFile + 'woventapestry174_5275dede-9cc7-4c6b-9170-eb09aff04ef2.webp?v=1687194404',
        175: imageFile + 'WovenTapestry175_fa1c199d-7d0f-4da4-92bb-09516f7f3152.webp?v=1687194411',
        184: imageFile + 'WovenTapestry184_fa3f1a58-ff98-4c93-8273-ad691be6c865.webp?v=1687194406',
        185: imageFile + 'WovenTapestry185_c2b2b4c2-a18e-425e-8dad-90361041fc92.webp?v=1687194411',
        186: imageFile + 'woventapestry186_d32d6d3f-d9a1-493d-9532-01e7b1f0930c.webp?v=1687194406',
      }
    }
  }
}

let designRug = {
  collection: "",
  color: "",
  fiberNameCamel: "",
  fiberName: null,
  fiberImage: "",
  fiberPrice: 0,
  brand: "",
  borderName: null,
  borderSKU: "",
  borderImage: "",
  borderPrice: 0,
  borderType: "",
  cornerSize: "",
  cornerStyle: "",
  cornerFinishPrice: 0,
  padIncluded: '',
  padPrice: 0,
  hidePrice: true,
  qty: 1,
  roundedCorners: false,
  roundedCornersPrice: 0,
  rugWidthFt: 0,
  rugWidthIn: 0,
  rugLengthFt: 0,
  rugLengthIn: 0,
  rugMaxWidth: 0,
  rugArea: 0,
  rugPer: 0,
  rugTotalPrice: 0,
};

// Vital component for allowing price level changes
const pricingState = {};
const bodyHTML = document.querySelector('body');
const borderStyleContainer = document.querySelector('.border-style-option-container');
const borderStickyEl = document.querySelector('.container__sticky');
const borderStyleConfirm = document.querySelector('.btn-border-style__confirm');
const fiberChoice = document.querySelector('.fiber-choice');
const fiberFilterContainer = document.querySelector('.fiber-filter-options-container');
const borderChoice = document.querySelector('.border-choice');
const borderStyleChoice = document.querySelector('.border-style-choice');
const variantChoice = document.querySelector('.variant-choice');
const borderVariantChoice = document.querySelector('.border-variant-choice');
const updateSize = document.querySelector('.update-size');
const btnRugPad = document.querySelector('.btn-rug-pad-choice');
const rugSize = document.getElementById('dyr-rug-size');
const standardRugSizeEl = document.querySelector('.standard-rug-sizes__buttons');
const mainFiberImage = document.getElementById('dyr-fiber');
const mainBorderImage = document.getElementById('dyr-border');
const dyrFiber = document.getElementById('dyr-rug-fiber');
const dyrBorder = document.getElementById('dyr-rug-border');
const dyrCornerFinish = document.getElementById('dyr-rug-corner-finish');
const dyrBorderSize = document.getElementById('dyr-rug-border-size');
const dyrRugPad = document.getElementById('dyr-rug-pad');
const dyrOptionsContent = document.querySelectorAll('.dyr-options__content');
const choiceTabs = document.querySelectorAll('.choice-tabs__tab');
const choiceTabsContainer = document.querySelector('.choice-tabs');
const dyrStandard1Price = document.getElementById('dyr-rug-standard1-price');
const dyrStandard2Price = document.getElementById('dyr-rug-standard2-price');
const dyrStandard3Price = document.getElementById('dyr-rug-standard3-price');
const dyrStandard4Price = document.getElementById('dyr-rug-standard4-price');
const dyrStandard5Price = document.getElementById('dyr-rug-standard5-price');
const dyrRugPrice = document.getElementById('dyr-rug-price');
const customWidthFt = document.getElementById('custom-width-feet');
const customWidthIn = document.getElementById('custom-width-inches');
const customLengthFt = document.getElementById('custom-length-feet');
const customLengthIn = document.getElementById('custom-length-inches');
const strMaxWidth = document.getElementById('p-max-width');
const numMaxWidth = document.getElementById('rug-max-width');
const dumbWarning = document.getElementById('dumbdumb');
const juteBraid = document.getElementById('jute-braid');
const serging = document.getElementById('serging');
const wovenOutdoor = document.getElementById('woven-outdoor');
const saveRug = document.getElementById('save-rug');
const btnSaveRug = document.getElementById('btn-save-rug');
const rugName = document.getElementById('rug-name');
const drpdnRugPad = document.getElementById('rug-pad-dropdown');
const rugPadContainer = document.querySelector('.rug-pad-container');
const btnFiberFilterViewAll = document.querySelector('.btn-fiber-filter-view-all');
const btnFiberFilter = document.querySelector('.btn-fiber-filter');
const btnColorFilter = document.querySelector('.btn-color-filter');
const drpdnFiberFilter = document.getElementById('fiber-filter-dropdown');
const drpdnColorFilter = document.getElementById('fiber-color-dropdown');
const fiberFilterChoice = document.getElementById('fiber-filter-choice');
const colorFilterChoice = document.getElementById('color-filter-choice');
const designerElement = document.querySelector('.designer-borders');
const designerElContainer = document.querySelector('.designer-borders-container');
const borderBtns = document.querySelector('.border-btns');
const btnDesigner = document.querySelector('.btn-designer-borders-filter');
const btnAllBorders = document.querySelector('.btn-border-all-filter');
const requiredFields = [designRug.fiberName, designRug.borderName, designRug.cornerSize, designRug.cornerStyle, designRug.padIncluded, designRug.rugArea];
const updateMessage = document.querySelector('.update-message');
const btnBackToTop = document.querySelector('.button__container--right');
const leftColumn = document.querySelector('.left-column');
const dyrHeadingLine = document.querySelector('.dyr-heading__line');
const noOutdoor = document.querySelector('.no-outdoor');
const tariffAmount = document.getElementById('dyr-rug-tariff');
const pricePlusTariff = document.getElementById('dyr-rug-price-plus-tariff');
const tariffIncludedMsg = document.getElementById('tariff-included');
const popupContainer = document.querySelector('.popup__container');
const materialVariants = document.querySelector('.material-variants');
const materialOverlay = document.querySelector('.overlay__material');
const variantChoiceClose = document.querySelector('.variant-choice__close');
const borderOverlay = document.querySelector('.overlay__borders');
const borderVariantChoiceClose = document.querySelector('.border-variant-choice__close');
const fiberSearch = document.getElementById('fiber-search');
const tariffEl = document.getElementById('dyr-rug-tariff')?.closest('.dyr-line-item') ?? null;
const subtotalEl = document.getElementById('dyr-rug-price-plus-tariff')?.closest('.dyr-line-item') ?? null;
const surchargeLine = document.getElementById('surcharge-line');

const tariffCharges = new Map([
  ['Coir', 1.2],
  ['Hemp', 3],
  ['Indoor/Outdoor', 1.75],
  ['Jute', 2.45],
  ['Seagrass', 2.45],
  ['Sisal - Classic', 1.6],
  ['Sisal - Designer', 3],
  ['Wool', 2.75],
  ['Wool Blends', 1.75],
  ['Wool and Sisal', 3],
  ['Braided Jute', 2.45],
])

const brands = new Map([
  ['Katha Living', 'KL'],
  ['Fibreworks', 'FW'],
]);

const warnings = new Map ([
  [0, dyrFiber],
  [1, dyrBorder],
  [2, dyrBorderSize],
  [3, dyrCornerFinish],
  [4, dyrRugPad],
  [5, rugSize],
  [dyrFiber, 'Rug Field Required'],
  [dyrBorder, 'Border Required'],
  [dyrBorderSize, 'Border Size Required'],
  [dyrCornerFinish, 'Corner Finish Required'],
  [dyrRugPad, 'Rug Pad Required'],
  [rugSize, 'Rug Size Required'],
])

let variantPicker;
let borderVariantPicker;
let borderStylePicker;
let usDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

// Calculate rug area and perimeter
const calcRugArea = function(lenFt, lenIn, widFt, widIn){
  const length = Number(lenIn) * .08333 + Number(lenFt);
  const width = Number(widIn) * .08333 + Number(widFt);
  return Math.ceil(length * width * 10) / 10;
}

const calcRugPer = function(lenFt, lenIn, widFt, widIn) {
  return (Number(lenIn) * .08333 + Number(widIn) * .08333 + Number(lenFt) + Number(widFt)) * 2;
}

// Show success/error message
const showUpdateEl = function(message, type, ms=1500) {
  updateMessage.textContent = message || 'Rug Updated';
  updateMessage.classList.remove('success', 'fail');
  updateMessage.classList.add('show-update', type);
  setTimeout(() => updateMessage.classList.remove('show-update'), ms);
}

// Visually update prices
const resetPrices = function(obj) {
  obj.rugTotalPrice = 0;
  if (customerPriceLevel > 0) {
    dyrRugPrice.textContent = ``;
    dyrStandard1Price.textContent = ``;
    dyrStandard2Price.textContent = ``;
    dyrStandard3Price.textContent = ``;
    dyrStandard4Price.textContent = ``;
    dyrStandard5Price.textContent = ``;
  }
}

const calcRugPrices = function(obj) {
  if (!obj.borderName || !obj.fiberName || customerPriceLevel === 0) return resetPrices(obj);
  if (!obj.cornerSize) return resetPrices(obj);
  const standardPrices = [];
  const length = Number(Number(obj.rugLengthIn) * .08333 + Number(obj.rugLengthFt));
  const lengthIn = Number(Number(obj.rugLengthIn) + Number(obj.rugLengthFt) * 12);
  const widthIn = Number(Number(obj.rugWidthIn) + Number(obj.rugWidthFt) * 12);
  if (widthIn > 145 && obj.padPrice > 0 && lengthIn > 145 && obj.rugPadOptions[0] == 'false') {
    obj.oversizedPadPrice = 25;
  } else {
    obj.oversizedPadPrice = 0;
  }
  if (customerType.split('+').includes(brands.get(designRug.brand))) {
    obj.hidePrice = false;
    if (obj.brand === 'Katha Living') {
      if (tariffsActive.KL) {
        obj.tariffAddition = obj.retired ? 0 : 8;
        obj.tariffTotal = Math.round(obj.tariffAddition * (Math.ceil(obj.rugMaxWidth * length * 10 / 9) / 10) * 100) / 100;
      } else {
        obj.tariffAddition = 0;
        obj.tariffTotal = 0;
      }
      obj.runnerFee = 0;
      if (obj.rugArea > 0) {
        obj.rugTotalPrice = Math.ceil(obj.fiberPrice * length * obj.rugMaxWidth + obj.borderPrice * obj.rugPer + obj.cornerFinishPrice + obj.roundedCornersPrice) + Math.ceil(obj.padPrice * obj.rugArea + obj.oversizedPadPrice);
        obj.hasCalcPrice = true;
      } else obj.rugTotalPrice = 0;
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 8 * obj.rugMaxWidth + obj.borderPrice * 21 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 20) + (Math.round(obj.tariffAddition * (Math.ceil(8 * obj.rugMaxWidth * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 9 * obj.rugMaxWidth + obj.borderPrice * 30 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 54) + (Math.round(obj.tariffAddition * (Math.ceil(9 * obj.rugMaxWidth * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 10 * obj.rugMaxWidth + obj.borderPrice * 36 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 80) + (Math.round(obj.tariffAddition * (Math.ceil(10 * obj.rugMaxWidth * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 12 * obj.rugMaxWidth + obj.borderPrice * 42 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 108) + (Math.round(obj.tariffAddition * (Math.ceil(12 * obj.rugMaxWidth * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 14 * obj.rugMaxWidth + obj.borderPrice * 48 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 140) + (Math.round(obj.tariffAddition * (Math.ceil(14 * obj.rugMaxWidth * 10 / 9) / 10) * 100) / 100));
    } else {
      if (tariffsActive.FW) {
        obj.tariffAddition = obj.retired ? 0 : tariffCharges.get(obj.fiber);
        obj.tariffTotal = Math.round(obj.tariffAddition * (Math.ceil(obj.rugArea * 10 / 9) / 10) * 100) / 100;
      } else {
        obj.tariffAddition = 0;
        obj.tariffTotal = 0;
      }
      if (widthIn <= 40 && lengthIn > 96) {
        obj.runnerFee = 3.1;
      } else {
        obj.runnerFee = 0;
      }
      if (obj.rugArea > 0) {
        obj.rugTotalPrice = Math.ceil((Number(obj.fiberPrice) + obj.runnerFee) * obj.rugArea + obj.borderPrice * obj.rugPer + obj.cornerFinishPrice + obj.roundedCornersPrice) + Math.ceil(obj.padPrice * obj.rugArea + obj.oversizedPadPrice);
        obj.hasCalcPrice = true;
      } else obj.rugTotalPrice = 0;
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 20 + obj.borderPrice * 21 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 20) + (Math.round(obj.tariffAddition * (Math.ceil(20 * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 54 + obj.borderPrice * 30 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 54) + (Math.round(obj.tariffAddition * (Math.ceil(54 * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 80 + obj.borderPrice * 36 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 80) + (Math.round(obj.tariffAddition * (Math.ceil(80 * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 108 + obj.borderPrice * 42 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 108) + (Math.round(obj.tariffAddition * (Math.ceil(108 * 10 / 9) / 10) * 100) / 100));
      standardPrices.push(Math.ceil((Number(obj.fiberPrice) * 140 + obj.borderPrice * 48 + obj.cornerFinishPrice + obj.roundedCornersPrice)) + Math.ceil(obj.padPrice * 140) + (Math.round(obj.tariffAddition * (Math.ceil(140 * 10 / 9) / 10) * 100) / 100));
    }
    if (customerPriceLevel > 0) {
      if (obj.hasCalcPrice) dyrRugPrice.textContent = `${usDollar.format(obj.rugTotalPrice)}`;
      if (obj.hasCalcPrice && tariffsActive[brands.get(obj.brand)]) {
        tariffAmount.textContent = `${usDollar.format(obj.tariffTotal)}`;
        pricePlusTariff.textContent = `${usDollar.format(obj.tariffTotal + obj.rugTotalPrice)}`;
      }
      dyrStandard1Price.textContent = (2.5 < obj.rugMaxWidth) ? `${usDollar.format(standardPrices[0])}` : '';
      dyrStandard2Price.textContent = (6 < obj.rugMaxWidth) ? `${usDollar.format(standardPrices[1])}` : '';
      dyrStandard3Price.textContent = (8< obj.rugMaxWidth) ? `${usDollar.format(standardPrices[2])}` : '';
      dyrStandard4Price.textContent = (9 < obj.rugMaxWidth) ? `${usDollar.format(standardPrices[3])}` : '';
      dyrStandard5Price.textContent = (10 < obj.rugMaxWidth) ? `${usDollar.format(standardPrices[4])}` : '';
    }
  } else {
    obj.hidePrice = true;
    obj.borderPrice = 0;
    obj.cornerFinishPrice = 0;
    obj.rugTotalPrice = 0;
    // obj.standard1Price = 0;
    // obj.standard2Price = 0;
    // obj.standard3Price = 0;
    // obj.standard4Price = 0;
    // obj.standard5Price = 0;
    dyrRugPrice.textContent = ``;
    dyrStandard1Price.textContent = ``;
    dyrStandard2Price.textContent = ``;
    dyrStandard3Price.textContent = ``;
    dyrStandard4Price.textContent = ``;
    dyrStandard5Price.textContent = ``;
  }
}

const reqFieldsUpdate = function(obj) {
  requiredFields[0] = obj.fiberName;
  requiredFields[1] = obj.borderName;
  requiredFields[2] = obj.cornerSize;
  requiredFields[3] = obj.cornerStyle;
  requiredFields[4] = obj.padIncluded;
  requiredFields[5] = obj.rugArea;
}

// Show where rug components are incomplete
const incRugWarning = function(arr) {
  for (let i = arr.length - 1; i > -1; i--) {
    if (arr[i] === '' || arr[i] === null || arr[i] === 0) {
      warnings.get(i).textContent = warnings.get(warnings.get(i));
      showUpdateEl(`${warnings.get(warnings.get(i))}`, 'fail');
      warnings.get(i).classList.add('warning');
    } else {
      warnings.get(i).classList.remove('warning');
    }
  }
}

// Warn users of outdoor use if border not serging
const showOutdoorWarning = function(rug) {
  if (!rug.fiber || !rug.borderType) return
  if (rug.fiber === 'Indoor/Outdoor' && rug.borderType === 'Serging' || rug.borderType === "Woven Outdoor") {
    noOutdoor.classList.add('hidden')
  } else if (rug.fiber === "Indoor/Outdoor") {
    noOutdoor.classList.remove('hidden')
  }
}

// Show/hide options based on fiber choice
const exceptions = function(obj) {
  if (obj.collection === 'Kochi' || obj.collection === 'Zira' || obj.collection === 'Bombay') {
      juteBraid.classList.remove('hidden');
  } else {
    juteBraid.classList.add('hidden');
  };
  if (obj.collection === 'Kochi' || obj.collection === 'Coir' || obj.collection === 'Bombay' || obj.excludeSerging) {
      serging.classList.add('hidden');
  } else {
    serging.classList.remove('hidden');
  };
  if (obj.collection === 'Bryce' || obj.collection === 'Zion') {
    wovenOutdoor.classList.remove('hidden');
  } else {
    wovenOutdoor.classList.add('hidden');
  };
  if (obj.collection === 'Eclipse') {
    showPads(obj.rugPadOptions, 'Eclipse has no primary backing, therefore all custom rug orders must include Attached 595 Pad for structural integrity.')
  } else if (obj.rugPadOptions[0] !== 'false') {
    const padMessage = `Ripples may form in your sisal boucle rug due to tension during border application and packaging. ${obj.fiberName} requires an Attached 595 Pad to reduce rippling.`
    showPads(obj.rugPadOptions, padMessage)
  } else {
    setPads()
  }
  if (obj.collection === 'Bombay' || obj.collection === 'BotanicalBlends' || obj.collection === 'Coir' || obj.collection === 'Kochi' || obj.collection === 'Malabar') {
    document.getElementById('square-narrow-cotton').classList.add('hidden');
    document.getElementById('square-narrow-jute').classList.add('hidden');
  } else {
    document.getElementById('square-narrow-cotton').classList.remove('hidden');
    document.getElementById('square-narrow-jute').classList.remove('hidden');
  }
  if (obj.collection === 'Kochi') {
    document.getElementById('mitered-medium-invisible-cotton').classList.add('hidden');
    document.getElementById('square-medium-invisible-cotton').classList.add('hidden');
    document.getElementById('square-medium-visible-cotton').classList.add('hidden');
    document.getElementById('mitered-medium-invisible-jute').classList.add('hidden');
    document.getElementById('square-medium-invisible-jute').classList.add('hidden');
    document.getElementById('square-medium-visible-jute').classList.add('hidden');
    document.getElementById('mitered-medium-invisible-jute-chenille').classList.add('hidden');
    document.getElementById('square-medium-invisible-jute-chenille').classList.add('hidden');
  } else {
    document.getElementById('mitered-medium-invisible-cotton').classList.remove('hidden');
    document.getElementById('square-medium-invisible-cotton').classList.remove('hidden');
    document.getElementById('square-medium-visible-cotton').classList.remove('hidden');
    document.getElementById('mitered-medium-invisible-jute').classList.remove('hidden');
    document.getElementById('square-medium-invisible-jute').classList.remove('hidden');
    document.getElementById('square-medium-visible-jute').classList.remove('hidden');
    document.getElementById('mitered-medium-invisible-jute-chenille').classList.remove('hidden');
    document.getElementById('square-medium-invisible-jute-chenille').classList.remove('hidden');
  }
}

const showPads = function(arr, message) {
  const rugPadDisclaimer = document.querySelector('.rug-pad-disclaimer');
  rugPadContainer.querySelectorAll('.option').forEach(el => el.classList.add('hidden'));
  arr.forEach(padNum => {
    const padEl = document.getElementById(`${padNum}pad`);
    padEl.classList.remove('hidden');
    if (arr.length === 1 && arr[0] === '595') {
      padEl.innerHTML = `Attached Non-Skid 595 *Required <img src="https://cdn.shopify.com/s/files/1/0743/0894/4182/files/593AttachedNonSkidBackinge1623255012252.webp?v=1687206006" width="180px" height="180px">`;
      pickRugPad(595)
    }
  })
  if (!rugPadDisclaimer){
    const htmlMessage = `<p class="rug-pad-disclaimer">${message}</p>`;
    rugPadContainer.insertAdjacentHTML('beforeend', htmlMessage);
  } else {
    rugPadDisclaimer.classList.remove('hidden');
    rugPadDisclaimer.textContent = message;
  }
}

// const unpick593Pad = function() {
//   const pad593 = document.getElementById('593pad');
//   rugPadContainer.querySelectorAll('.option').forEach(el => el.classList.remove('hidden'));
//   pad593.innerHTML = `Attached Non-Skid 593 <img src="https://cdn.shopify.com/s/files/1/0743/0894/4182/files/593AttachedNonSkidBackinge1623255012252.webp?v=1687206006" width="180px" height="180px">`;
//   const rugPadDisclaimer = document.querySelector('.rug-pad-disclaimer');
//   if (rugPadDisclaimer) rugPadDisclaimer.classList.add('hidden');
// }


// Get fiber price from API
const getPrice = function(url, prod) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token':'f9f28e22142146072bb46fa427213264'
    },
    body: JSON.stringify({
      query: `{
      product(id: "gid:\/\/shopify\/Product\/${prod}") {
      metafield(namespace: "custom", key: "price_${customerPriceLevel}") {
      value
      }
      variants(first: 50) {
      nodes {
      id
      metafield(namespace: "custom", key: "${customerPriceLevel}_") {
      value
      }
      }
      }
      }
      }
      `
    })
  }).then(res => {
   if (!res.ok) console.log(res);
    return res.json()
  })
}

// Get variant info from API
const getVariantInfo = async function(url, prodID) {
  const variants = [];
  const data = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token':'f9f28e22142146072bb46fa427213264'
    },
    body: JSON.stringify({
      query: `
      {
  product(id: "gid:\/\/shopify\/Product\/${prodID}") {
    variants(first: 50) {
      nodes {
        id
        title
        sku
        image {
          url(transform: {maxWidth: 120})
        }
        no_serging: metafield(namespace: "custom", key: "no_serging") {
        value
        }
        rug_pad_options: metafield(namespace: "custom", key: "rug_pad_options") {
        value
        }
        retired: metafield(namespace: "custom", key: "retired") {
        value
        }
      }
    }
  }
}`
    })
  }).then(res => res.json());
  console.log(data)
  data.data.product.variants.nodes.forEach(obj => {
    variants.push({
    id: obj.id.slice(-14),
    title: obj.title,
    handle: obj.title.toLowerCase().replaceAll(' ', '-'),
    camel: obj.title.split(' ').map(word => word[0].toUpperCase() + word.slice(1)).join('').replaceAll(' ', '').replaceAll('-','').replaceAll("'","").replaceAll(".",""),
    sku: obj.sku || '',
    image: obj.image.url,
    excludeSerging: obj.no_serging?.value === "true",
    retired: obj.retired?.value === "true",
    rugPadOptions: obj.rug_pad_options?.value ?? false,
  })
  })
  return variants;
}

// Render fiber variants when collection is chosen
const renderVariantOptions = function(arr, prodHandle, prodID, prodCamel) {
  const listHTML = arr.map(obj => 
    `<li class="collection__variants option" id="${obj.handle}-${obj.sku}" data-product="${prodCamel}" data-variant="${obj.camel}" data-productid="${prodID}" data-variantid="${obj.id}" data-exclude-serging=${obj.excludeSerging ? true : false} data-retired=${obj.retired ? true : false} data-rug-pad-options=${obj.rugPadOptions}>
    <img src="${obj.image}">
    <p class="collection__variants-info">${obj.sku} ${obj.title}</p>
    </li>`           
               ).join('');
  const html = `
  <ul id="${prodHandle}-variants">
  ${listHTML}
  </ul><div class="variant-choice__close" data-tab="materials"><svg
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="false"
  focusable="false"
  class="icon icon-close"
  fill="#000000"
  viewBox="0 0 18 17"
>
  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
</svg></div>`;
  variantChoice.innerHTML = '';
  variantChoice.insertAdjacentHTML('afterbegin', html);
}

const figureFiberPrice = async function(productID, variantID) {
  let price;
  if (customerPriceLevel) {
          await getPrice(`/api/2024-01/graphql.json`, productID).then(data => {
            if(data.data.product.metafield) {
              price = data.data.product.metafield.value;
              designRug.fiberPrice = price;
              return Number(price);
            } else {
              price = data.data.product.variants.nodes.find(obj => obj.id === `gid://shopify/ProductVariant/${variantID}`).metafield.value;
              designRug.fiberPrice = price;
              return Number(price);
            }
          }).catch(err => console.log(err.message))
        } else {
          return 0;
        }
}

// Undo border options to conform to compatability
const resetBorder = function() {
    designRug.borderType = '';
    designRug.borderName = "";
    designRug.borderVariant = "";
    designRug.borderImage = "";
    designRug.borderPrice = 0;
    designRug.cornerSize = "";
    designRug.cornerStyle = "";
    designRug.cornerFinishPrice = 0;
    dyrBorder.textContent = '';
    dyrBorderSize.textContent = '';
    dyrCornerFinish.textContent = '';
    mainBorderImage.src = '';
    mainBorderImage.classList.add('clear');
    reqFieldsUpdate(designRug);
    borderStyleConfirm.classList.add('disabled');
}

// Hide dropdowns if clicked outside dropdown area
window.onclick = function(e) {
  if (!e.target.matches('.btn-fiber-filter')) {
    drpdnFiberFilter.classList.add('hidden');
  }
  if (!e.target.matches('.btn-color-filter')) {
    drpdnColorFilter.classList.add('hidden');
  }
  if (e.target.classList.contains('option__fiber')) {
    drpdnFiberFilter.classList.add('hidden');
    drpdnColorFilter.classList.add('hidden');
  }
}

const pickRugPad = function(num, event=true) {
  designRug.padPrice = rugPads[num][customerPriceLevel];
  pricingState.padNum = num;
  designRug.padIncluded = rugPads[num].name;
  dyrRugPad.textContent = designRug.padIncluded;
  dyrRugPad.classList.remove('warning');
  calcRugPrices(designRug);
  reqFieldsUpdate(designRug);
  if (event) showUpdateEl('Rug Pad Updated', 'success');
  addActiveState(rugPadContainer, document.getElementById(`${num}pad`));
}

// Toggle GUI for fiber filter dropdown
const showFiberFilterOptions = function() {
  drpdnFiberFilter.classList.toggle('hidden');
}

// Toggle GUI for color filter dropdown
const showColorFilterOptions = function() {
  drpdnColorFilter.classList.toggle('hidden');
}

// Toggle GUI to show all borders tab
const showAllBorders = function() {
  // if (btnAllBorders.classList.contains('inactive')) {
    borderOptionContainer.classList.remove('hidden');
    borderVariantChoice.classList.remove('hidden');
    designerElContainer.classList.add('hidden');
    btnDesigner.classList.add('inactive');
    btnAllBorders.classList.remove('inactive');
    borderStyleContainer.classList.add('invisible');
    if (!borderVariantChoice.classList.contains('hidden__aside')) toggleBorderVariants();
  // }
}

// Toggle GUI to show designer borders tab
const showDesignerBorders = function() {
  // if (btnDesigner.classList.contains('inactive')) {
    // borderOptionContainer.classList.add('hidden');
    if (borderVariantPicker) borderVariantPicker.classList.add('hidden');
    designerElContainer.classList.remove('hidden');
    btnDesigner.classList.remove('inactive');
    btnAllBorders.classList.add('inactive');
    borderStyleContainer.classList.add('invisible');
    if (borderVariantChoice.classList.contains('hidden__aside')) toggleBorderVariants();
  // }
}

// Show border specifications on border style picker
const showBorderSpecs = function(str) {
  borderStyleContainer.querySelectorAll('.show-face-specs__spec').forEach(el => el.classList.add('hidden'));
  borderStyleContainer.querySelectorAll('.show-face-specs__contact').forEach(el => el.classList.add('hidden'));
  borderStyleContainer.querySelectorAll(`.${str}`).forEach(el => el.classList.remove('hidden'));
}

// Display our designer borders depending on the fiber chosen
const updateDesignBorders = function(product, variant) {
  designerElement.innerHTML = '';
  fiberProducts[product].variants[variant].borders.forEach(id => designerElement.append(Object.values(borderProducts).flatMap(obj => Object.values(obj.variants)).find(obj => obj.id === id).element.cloneNode(true)));
  if (designerElement.innerHTML === '') designerElement.innerHTML = '<p>Serging Recommended</p>';
}

const updateRugMaterial = async function(product, variant, productID, variantID, excludeSerging, rugPadOptions, retired) {
  if (excludeSerging !== 'true') {
    designRug.fiberImage = designRug.borderName === 'Coordinating Serging' ? fiberProducts[product].variants[variant].sergedImg : fiberProducts[product].variants[variant].mainImg;
    designRug.excludeSerging = false;
  } else {
    designRug.fiberImage = fiberProducts[product].variants[variant].mainImg;
    designRug.excludeSerging = true;
  }
  designRug.retired = retired == 'true' ? true : false;
  designRug.brand = fiberProducts[product].brand;
  // toggleTariff(designRug.brand);
  pricingState.productID = productID;
  pricingState.variantID = variantID;
  await figureFiberPrice(productID, variantID);
  designRug.fiberName = `${fiberProducts[product].name} ${fiberProducts[product].variants[variant].sku} ${fiberProducts[product].variants[variant].name}`;
  reqFieldsUpdate(designRug);
  designRug.fiberNameCamel = `${product}`;
  designRug.collection = `${product}`;
  designRug.color = `${variant}`;
  designRug.fiber = fiberProducts[product].fiber;
  designRug.rugMaxWidth = fiberProducts[product].maxWidth > 0 ? fiberProducts[product].maxWidth : fiberProducts[product].variants[variant].width;
  designRug.rugPadOptions = rugPadOptions;
  numMaxWidth.textContent = `${String(designRug.rugMaxWidth).split('.')[0]}'${Math.round(Number('.' + String(designRug.rugMaxWidth).split('.')[1])*12) || 0}''`;
  strMaxWidth.classList.remove('hidden');
  if (Number(designRug.rugWidthFt) + Math.round(designRug.rugWidthIn * .0833 * 100) / 100 > designRug.rugMaxWidth) {
    designRug.rugWidthFt = 0;
    designRug.rugWidthIn = 0;
    designRug.rugLengthFt = 0;
    designRug.rugLengthIn = 0;
    designRug.rugArea = 0;
    designRug.rugPer = 0;
    rugSize.textContent = '';
    dumbWarning.classList.remove('hidden');
  }
  
  if (designRug.collection !== 'Kochi' || designRug.collection !== 'Zira' || designRug.collection !== 'Bombay') {
    if (designRug.borderType === 'Jute Braid') {
    juteBraid.classList.add('hidden');
     resetBorder();
    }
  }
  if (designRug.collection === 'Kochi' || designRug.collection === 'Coir' || designRug.collection === 'Bombay' || excludeSerging === 'true') {
    if (designRug.borderType === 'Serging') {
    serging.classList.add('hidden');
    resetBorder();
    designRug.fiberImage = fiberProducts[product].variants[variant].mainImg;
    }
  }
  if (designRug.collection !== 'Bryce' || designRug.collection !== 'Zion') {
    if (designRug.borderType === 'Woven Outdoor') {
    wovenOutdoor.classList.add('hidden');
    resetBorder();
    }
  }
  calcRugPrices(designRug);
  mainFiberImage.src = designRug.fiberImage;
  mainFiberImage.classList.remove('clear');
  document.querySelector('.rug-design-image').classList.remove('thin-border');
  dyrFiber.textContent = designRug.fiberName;
  dyrFiber.classList.remove('warning');
  exceptions(designRug)
  showOutdoorWarning(designRug);
  updateDesignBorders(product, variant);
}

const updateBorder = function(product, variant) {
      designRug.borderSKU = variant.sku;
      designRug.borderImage = variant.mainImg;
      designRug.fiberImage !== '' ? designRug.fiberImage = fiberProducts[designRug.collection].variants[designRug.color].mainImg : designRug.fiberImage = '';
      designRug.borderName = `${product.name} ${variant.sku} ${variant.name}`;
      designRug.borderType = `${product.name}`;
      mainBorderImage.src = designRug.borderImage;
      mainFiberImage.src = designRug.fiberImage;
      mainBorderImage.classList.remove('clear');
      dyrBorder.textContent = designRug.borderName;
      dyrBorder.classList.remove('warning');
      designRug.cornerStyle = '';
      designRug.cornerSize = '';
      designRug.borderPrice = product[customerPriceLevel] > 0 ? product[customerPriceLevel] : variant[customerPriceLevel];
      designRug.cornerFinishPrice = 0;
      dyrCornerFinish.textContent = '';
      dyrBorderSize.textContent = '';
      reqFieldsUpdate(designRug);
      calcRugPrices(designRug);
      showOutdoorWarning(designRug);
      borderStyleConfirm.classList.add('disabled');
      if (borderStylePicker && borderStylePicker !== product.corners) {
      borderStylePicker.classList.add('hidden');
    }
      if (borderStylePicker && borderStylePicker.id == product.corners.id && borderStylePicker.classList.contains('hidden')) {
      borderStylePicker.classList.remove('hidden');
      } else if (borderStylePicker && borderStylePicker.id == product.corners.id && !borderStylePicker.classList.contains('hidden')) {
      } else { 
    product.corners.classList.toggle('hidden');
    borderStylePicker = product.corners;
  }
}

const updateBorderSerging = function(event) {
    mainBorderImage.src = designRug.borderImage = '';
    designRug.borderPrice = borderProducts.Serging[customerPriceLevel];
    designRug.cornerFinishPrice = 0;
    dyrCornerFinish.textContent = designRug.cornerStyle = 'Serged';
    dyrBorderSize.textContent = designRug.cornerSize = 'N/A';
    dyrBorder.textContent = designRug.borderName = 'Coordinating Serging';
    designRug.borderType = 'Serging';
    reqFieldsUpdate(designRug);
    dyrBorder.classList.remove('warning');
    dyrBorderSize.classList.remove('warning');
    dyrCornerFinish.classList.remove('warning');
    mainBorderImage.classList.add('clear');
    confirmBorderStyle();
    calcRugPrices(designRug);
    showOutdoorWarning(designRug);
    if (event) {
      showUpdateEl('Border Updated', 'success');
      addActiveState(borderOptionContainer, borderProducts.Serging.element)
      if (borderVariantPicker) borderVariantPicker.classList.add('hidden');
      if (borderStylePicker && borderStylePicker !== borderProducts.Serging.corners) {
        borderStylePicker.classList.add('hidden');
      }
      if (borderStylePicker && borderStylePicker.id == borderProducts.Serging.corners.id && borderStylePicker.classList.contains('hidden')) {
        borderStylePicker.classList.remove('hidden');
        } else if (borderStylePicker && borderStylePicker.id == borderProducts.Serging.corners.id && !borderStylePicker.classList.contains('hidden')) {
        } else { 
        borderProducts.Serging.corners.classList.toggle('hidden');
        borderStylePicker = borderProducts.Serging.corners;
        }
    }
    if (designRug.fiberNameCamel !== '') {
      designRug.fiberImage = fiberProducts[designRug.collection].variants[designRug.color].sergedImg;
      mainFiberImage.src = designRug.fiberImage;
    }
}

const updateBorderStyle = function(product, style, str, event=true) {
  const [firstWord, ...cornerSize] = str.split(' - ');
    designRug.cornerSize = cornerSize[0];
    dyrCornerFinish.textContent = designRug.cornerStyle = firstWord;
    reqFieldsUpdate(designRug);
    dyrBorderSize.textContent = cornerSize.join(' ');
    dyrCornerFinish.classList.remove('warning');
    dyrBorderSize.classList.remove('warning');
    designRug.borderImage = borderStyles[product][style].image[designRug.borderSKU];
    mainBorderImage.src = designRug.borderImage;
    pricingState.cornerProduct = product;
    pricingState.cornerStyle = style;
    customerPriceLevel > 0 ? designRug.borderPrice = borderStyles[product][style].price[customerPriceLevel] : designRug.borderPrice = 0;
    if ( designRug.cornerStyle == 'Mitered' && customerPriceLevel > 0) {
      designRug.cornerFinishPrice = borderStyles[product].Mitered.price[customerPriceLevel];
    } else {
      designRug.cornerFinishPrice = 0;
    }
    calcRugPrices(designRug);
    if (event) showUpdateEl('Border Updated', 'success');
    borderStyleConfirm.classList.remove('disabled');
}

const updateRugSize = function(widthFt, widthIn, lengthFt, lengthIn, event=true) {
  if (widthIn >= 12 || lengthIn >= 12) return showUpdateEl('Inches must be less than 12', 'fail');
  if (widthIn < 0 || widthFt < 0 || lengthFt < 0 || lengthIn < 0) return showUpdateEl('Rug Size Invalid', 'fail')
  designRug.rugWidthFt = Number(widthFt);
  designRug.rugWidthIn = Number(widthIn);
  designRug.rugLengthFt = Number(lengthFt);
  designRug.rugLengthIn = Number(lengthIn);
  rugSize.textContent = `${designRug.rugWidthFt}'${designRug.rugWidthIn}'' x ${designRug.rugLengthFt}'${designRug.rugLengthIn}''`;
  rugSize.classList.remove('warning');
  designRug.rugArea = calcRugArea(designRug.rugLengthFt, designRug.rugLengthIn, designRug.rugWidthFt, designRug.rugWidthIn);
  designRug.rugPer = calcRugPer(designRug.rugLengthFt, designRug.rugLengthIn, designRug.rugWidthFt, designRug.rugWidthIn);
  reqFieldsUpdate(designRug);
  calcRugPrices(designRug);
  if (event) showUpdateEl('Size Updated', 'success');
}

// Shows materials by fiber chosen
const filterOptions = {
  fiber: null,
  color: null,
}

const applyFilters = function(options) {
  const fiber = options.fiber;
  const color = options.color;
  fiberOptions.forEach(function(obj) {
    document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
  })
  btnFiberFilter.classList.add('inactive');
  btnColorFilter.classList.add('inactive');
  btnFiberFilterViewAll.classList.add('inactive');
  fiberFilterChoice.textContent = "Filter By Fiber";
  colorFilterChoice.textContent = "Filter By Color";

  if (fiber !== null) {
    fiberOptions.filter(obj => obj.fiber !== fiber).forEach(function(obj) {
      document.getElementById(`${obj.productTitleHandle}`).classList.add('hidden');
    })
    fiberFilterChoice.textContent = fiber;
    btnFiberFilter.classList.remove('inactive');
  }

  if (color !== null) {
    btnFiberFilterViewAll.classList.add('inactive');
    btnColorFilter.classList.remove('inactive');
    colorFilterChoice.textContent = color;

    fiberOptions.filter(obj => obj.variants.every(v => v.color !== color)).forEach(obj => {
      document.getElementById(`${obj.productTitleHandle}`).classList.add('hidden');
    });

    fiberOptions.filter(obj => obj.variants.some(v => v.color === color)).forEach(obj => {
      const colorImg = obj.variants.find(v => v.color === color);
      // document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
      document.querySelector(`#${obj.productTitleHandle} img`).src = colorImg.mainImgSmall;
    })
  } else {
    fiberOptions.forEach(function(obj) {
      document.querySelector(`#${obj.productTitleHandle} img`).src = obj.productImageUrl;
    });
  }
  setFilterOptions()
}

const filterByFiber = function(str) {
  filterOptions.fiber = str === "View All" ? null : str;
  document.querySelectorAll('.circle-graphic__fiber-filter').forEach(el => {
    el.classList.remove('active');
  });
  // document.getElementById(`fiber-circle__${str.replace(" ", "-")}`).classList.add('active');
  applyFilters(filterOptions);
};

// Shows materials by color chosen and swaps images
const filterByColor = function(str) {
  filterOptions.color = str === "View All" ? null : str;
  document.querySelectorAll('.circle-graphic__color-filter').forEach(el => {
    el.classList.remove('active');
  });
  // document.getElementById(`color-circle__${str.replace(" ", "-")}`).classList.add('active');
  applyFilters(filterOptions);
}



// Shows materials by fiber chosen
// const filterByFiber = function(str) {
//   if (str !== 'View All') {
//     fiberOptions.forEach(function(obj) {
//       document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
//     })
//   fiberOptions.filter(obj => obj.fiber !== str).forEach(function(obj) {
//     document.getElementById(`${obj.productTitleHandle}`).classList.add('hidden');
//     fiberFilterChoice.textContent = str;
//     colorFilterChoice.textContent = 'Filter By Color';
//     btnFiberFilter.classList.remove('inactive');
//     btnColorFilter.classList.add('inactive');
//     btnFiberFilterViewAll.classList.add('inactive');
//   })
// } else {
//     fiberOptions.forEach(function(obj) {
//       document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
//     })
//     fiberFilterChoice.textContent = str;
//     colorFilterChoice.textContent = 'Filter By Color';
//     btnFiberFilter.classList.remove('inactive');
//     btnColorFilter.classList.add('inactive');
//     btnFiberFilterViewAll.classList.add('inactive');
// }
// };

// // Shows materials by color chosen and swaps images
// const filterByColor = function(str) {
//   fiberOptions.forEach(function(obj) {
//     document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
//     document.querySelector(`#${obj.productTitleHandle} img`).src = obj.productImageUrl;
//     });
//   colorFilterChoice.textContent = str;
//   fiberFilterChoice.textContent = 'Filter By Fiber';
//   btnColorFilter.classList.remove('inactive');
//   btnFiberFilter.classList.add('inactive');
//   btnFiberFilterViewAll.classList.add('inactive');
//   if (str === 'View All') return;
//   fiberOptions.filter(obj => obj.variants.every(v => v.color !== str)).forEach(obj => {
//     document.getElementById(`${obj.productTitleHandle}`).classList.add('hidden');
//   });
//   fiberOptions.filter(obj => obj.variants.some(v => v.color === str)).forEach(obj => {
//     const colorImg = obj.variants.find(v => v.color === str);
//     document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
//     document.querySelector(`#${obj.productTitleHandle} img`).src = colorImg.mainImgSmall;
//   })
// }

const searchByCollection = function(str) {
  fiberOptions.forEach(obj => {
    document.getElementById(`${obj.productTitleHandle}`).classList.add('hidden');
  })
  fiberOptions.filter(obj => obj.productTitle.toLowerCase().includes(str.toLowerCase())).forEach(obj => {
    document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
  })
}

// Shows all materials
const filterByFiberViewAll = function(str) {
    // fiberOptions.forEach(function(obj) {
    //   document.getElementById(`${obj.productTitleHandle}`).classList.remove('hidden');
    // });
    // filterByColor('View All');
    // fiberFilterChoice.textContent = 'Filter By Fiber';
    // colorFilterChoice.textContent = 'Filter By Color';
    // btnFiberFilter.classList.add('inactive');
    // btnColorFilter.classList.add('inactive');
    // btnFiberFilterViewAll.classList.remove('inactive');

    filterOptions.fiber = null;
    filterOptions.color = null;
    applyFilters(filterOptions)
    fiberSearch.value = "";
};

// Adds green border around clicked element
const addActiveState = function(parentEl, el=null) {
  parentEl.querySelectorAll('.option').forEach(el => el.classList.remove('active__border'));
  if (el) el.classList.add('active__border');
}

// Show/Hide Variants and Overlay
const toggleVariants = function() {
  materialVariants.classList.toggle('hidden__aside');
  materialOverlay.classList.toggle('invisible');
  optionContainer.classList.toggle('no-scroll');
}

const toggleBorderVariants = function() {
  borderVariantChoice.classList.toggle('hidden__aside');
  borderOverlay.classList.toggle('invisible');
  borderOptionContainer.classList.toggle('no-scroll');
}

choiceTabsContainer.addEventListener('click', function(e) {
  const clicked = e.target.closest('.choice-tabs__tab');
  if(!clicked) return;
  choiceTabs.forEach(t => t.classList.remove('choice-tabs__tab--active'));
  clicked.classList.add('choice-tabs__tab--active');
  const content = clicked.dataset['choice'];
  dyrOptionsContent.forEach(el => el.classList.remove('dyr-options__active'));
  document.querySelectorAll(`[data-option="${content}"]`).forEach(el => el.classList.add('dyr-options__active'));
  showAllBorders();
})

optionContainer.addEventListener('click', async function(e) {
  if (variantChoice.contains(e.target) || e.target === variantChoice) return;
  if (materialOverlay.contains(e.target) || e.target === materialOverlay) return toggleVariants();
  const product = e.target.closest('.option');
  if (!product) return;
  const productID = product.getAttribute('data-product-id');
  const productHandle = product.id;
  const productCamel = product.getAttribute('data-product-camel');
  const variants = await getVariantInfo('/api/2024-01/graphql.json', productID);
  renderVariantOptions(variants, productHandle, productID, productCamel);
  addActiveState(optionContainer, product);
  toggleVariants();
})

designerElContainer.addEventListener('click', function(e) {
  if (e.target.classList.contains('option')) return;
  let border;
  if (e.target.id) {
    border = e.target;
  } else {
    border = e.target.closest('li');
  }
  const product = Object.values(borderProducts).filter(obj => Object.values(obj.variants).length > 1).find(obj => Object.values(obj.variants).flat().find(obj => obj.element.id === border.id));
  const variant = Object.values(product.variants).find(obj => obj.element.id === border.id);
  updateBorder(product, variant);
  borderStyleContainer.classList.remove('invisible');
  const elementString = border.dataset.optionProduct;
  showBorderSpecs(elementString);
  showUpdateEl('Border Updated', 'success');
  addActiveState(designerElContainer, border);
  addActiveState(borderOptionContainer);
})

borderProducts.Serging.element.addEventListener('click', updateBorderSerging.bind(null, true))

for (const [product, value] of Object.entries(borderProducts)) {
  if (product === 'Serging') continue;
  for (const [method, value2] of Object.entries(value.borderStyles)) {
    value2.element.addEventListener('click', updateBorderStyle.bind(null, product, method, value2.name));
  }
}

updateSize.addEventListener('submit', function (e) {
  e.preventDefault();
  if (Number(customWidthFt.value) + Math.round(Number(customWidthIn.value) * .08333 * 100)/100 > designRug.rugMaxWidth) {
    dumbWarning.textContent = designRug.fiberName ? 'Rug is wider than max width allowed' : 'Please choose a rug field and color first';
    dumbWarning.classList.remove('hidden');
  } else {
    dumbWarning.classList.add('hidden');
    updateRugSize(Number(customWidthFt.value), Number(customWidthIn.value), Number(customLengthFt.value), Number(customLengthIn.value));
  }
})

standardRugSizeEl.addEventListener('click', function(e) {
  const clicked = e.target.closest('.standard-rug-btn');
  if (!clicked) return;
   if (Number(clicked.dataset['widthft']) + Math.round(Number(clicked.dataset['widthin']) * .08333 * 100)/100 > designRug.rugMaxWidth) {
    dumbWarning.textContent = designRug.fiberName ? 'Rug is wider than max width allowed' : 'Please choose a collection and color first'
    dumbWarning.classList.remove('hidden');
  } else {
    dumbWarning.classList.add('hidden');
    updateRugSize(Number(clicked.dataset['widthft']), Number(clicked.dataset['widthin']), Number(clicked.dataset['lengthft']), Number(clicked.dataset['lengthin']));
  }
})

variantChoice.addEventListener('click', function(e) {
  if (e.target.closest('div').classList.contains('variant-choice__close')) return toggleVariants();
  const clickedVariant = e.target.closest('.option');
  if (!clickedVariant) return;
  const product = e.target.closest('.collection__variants').dataset['product'];
  const variant = e.target.closest('.collection__variants').dataset['variant'];
  const productID = e.target.closest('.collection__variants').dataset['productid'];
  const variantID = e.target.closest('.collection__variants').dataset['variantid'];
  const excludeSerging = e.target.closest('.collection__variants').dataset['excludeSerging'];
  const retired = e.target.closest('.collection__variants').dataset['retired'];
  const rugPadOptions = e.target.closest('.collection__variants').dataset['rugPadOptions'].replaceAll('"]', '').replaceAll('["', '').split(',');
  updateRugMaterial(product, variant, productID, variantID, excludeSerging, rugPadOptions, retired);
  showUpdateEl('Collection Updated', 'success');
  addActiveState(variantChoice, e.target.closest('li'));
})

// Allow admins to change price level from dropdown
window.addEventListener('load', function(){
  const priceLevelDrpdn = document.getElementById('price-level-dropdown');
  if (!priceLevelDrpdn) return
    priceLevelDrpdn.addEventListener('change', async function() {
      customerPriceLevel = priceLevelDrpdn.value;
      if (!designRug.fiberName) return;
      await figureFiberPrice(pricingState.productID, pricingState.variantID);
      if (!designRug.borderName) return;
      if (designRug.borderName == 'Coordinating Serging') {
        designRug.borderPrice = borderProducts.Serging[customerPriceLevel];
      } else {
      designRug.borderPrice = borderStyles[pricingState.cornerProduct][pricingState.cornerStyle].price[customerPriceLevel];
        if ( designRug.cornerStyle == 'Mitered' && customerPriceLevel > 0) {
        designRug.cornerFinishPrice = borderStyles[pricingState.cornerProduct].Mitered.price[customerPriceLevel];
      } else {
        designRug.cornerFinishPrice = 0;
      }
      }
      if (designRug.padIncluded === '') return;
      designRug.padPrice = rugPads[pricingState.padNum][customerPriceLevel];
      calcRugPrices(designRug);
    })
})

borderVariantChoiceClose.addEventListener('click', toggleBorderVariants)
borderOverlay.addEventListener('click', toggleBorderVariants)

for (const [product, value] of Object.entries(borderProducts)) {
  if (product === 'Serging') continue;
  value.element.addEventListener('click', function() {
    showAllBorders()
    if (borderVariantPicker && borderVariantPicker !== value.variant) {
      borderVariantPicker.classList.add('hidden');
      borderStyleContainer.classList.add('invisible');
    }
    if (borderVariantPicker === value.variant) {
    // if (borderVariantPicker === value.variant && borderVariantPicker.classList.contains('hidden')) {
      borderVariantPicker.classList.remove('hidden');
      } else { 
    value.variant.classList.toggle('hidden');
    borderStyleContainer.classList.add('invisible');
    borderVariantPicker = value.variant;
    }
     if (borderStylePicker && borderStylePicker !== value.corners) {
      borderStylePicker.classList.add('hidden');
    }
      if (borderStylePicker && borderStylePicker.id == value.corners.id && borderStylePicker.classList.contains('hidden')) {
      borderStylePicker.classList.remove('hidden');
      value.variant.classList.toggle('hidden');
      } else if (borderStylePicker && borderStylePicker.id == value.corners.id && !borderStylePicker.classList.contains('hidden')) {
      } else { 
    value.corners.classList.toggle('hidden');
    borderStylePicker = value.corners;
    }
    addActiveState(borderOptionContainer, value.element);
    toggleBorderVariants();
  })
  for (const [method, value2] of Object.entries(value.variants)) {
    value2.element.addEventListener('click', function(e) {
      updateBorder(value, value2);
      const elementString = value2.element.closest('li').dataset.optionProduct;
      showBorderSpecs(elementString);
      pricingState.borderProduct = value;
      pricingState.borderVariant = value2;
      showUpdateEl('Border Updated', 'success');
      addActiveState(borderVariantChoice, value2.element);
      addActiveState(designerElContainer);
      borderStyleContainer.classList.remove('invisible');
      borderStyleConfirm.classList.add('disabled');
    })
  }
}

borderVariantChoice.addEventListener('mouseover', function(e) {
  const borderVariant = e.target.closest('.option');
  if (!borderVariant) return mainBorderImage.src = designRug.borderImage;
  mainBorderImage.classList.remove('clear');
  mainBorderImage.src = borderVariant.querySelector('img').src.replace('width=80', 'width=500');
})

bodyHTML.addEventListener('mouseover', function(e) {
  const hover = e.target.closest('.dyr-options__content');
  if (hover && hover.classList.contains('border-variant-choice')) return;
  if (designRug.borderImage !== '') {
    mainBorderImage.src = designRug.borderImage;
  } else {
    mainBorderImage.classList.add('clear');
  }
})

fiberSearch.addEventListener('input', function(e) {
  filterOptions.fiber = null;
  filterOptions.color = null;
  applyFilters(filterOptions)
  searchByCollection(fiberSearch.value)
});

// General GUI Functions
// Show/hide tariff
// const toggleTariff = function(brand) {
//   if (customerPriceLevel === 0) return;
//   if (tariffsActive[brands.get(brand)]) {
//     tariffEl.classList.remove('hidden');
//     subtotalEl.classList.remove('hidden');
//     surchargeLine.classList.remove('hidden');
//   } else {
//     tariffEl.classList.add('hidden');
//     subtotalEl.classList.add('hidden');
//     surchargeLine.classList.add('hidden');
//   }
// }


// Back to top button - show/hide and scroll
const backToTop = function(ent) {
  const [entry] = ent;
  if (!entry.isIntersecting) {
    btnBackToTop.classList.remove('hidden');
  } else {
  btnBackToTop.classList.add('hidden');
  }
};

// Confirm border style choice and hide border styles
const confirmBorderStyle = function() {
  borderStyleContainer.classList.add('invisible');
}

borderStyleConfirm.addEventListener('click', confirmBorderStyle);


// Show back to top button
const btnShowObs = new IntersectionObserver(backToTop, {
  root: null,
  threshold: 0,
});
btnShowObs.observe(dyrHeadingLine);

btnBackToTop.addEventListener('click', function(e) {
    dyrHeadingLine.scrollIntoView({behavior: 'smooth'})
})

// Set filter options
// const fiberFilter = ['Coir', 'Hemp', 'Indoor/Outdoor', 'Jute', 'Luxe', 'Seagrass', 'Sisal - Classic', 'Sisal - Designer', 'Wool', 'Wool Blends', 'Wool and Sisal', 'View All'];
// const colorFilter = ['Beige', 'Black', 'Blue', 'Brown', 'Dark Gray', 'Gray', 'Green', 'Gold', 'Honey', 'Ivory', 'Linen', 'Navy', 'Purple', 'Red', 'Spice', 'Tan', 'Taupe', 'Terra Cotta', 'Yellow', 'View All']
const fiberFilterOptions = ['Coir', 'Hemp', 'Indoor/Outdoor', 'Jute', 'Luxe', 'Seagrass', 'Sisal - Classic', 'Sisal - Designer', 'Wool', 'Wool Blends', 'Wool and Sisal', 'View All'];
const colorFilterOptions = ['Beige', 'Black', 'Blue', 'Brown', 'Dark Gray', 'Gray', 'Green', 'Gold', 'Honey', 'Ivory', 'Linen', 'Navy', 'Purple', 'Red', 'Spice', 'Tan', 'Taupe', 'Terra Cotta', 'Yellow', 'View All']
const fiberFilter = fiberFilterOptions.filter(str => fiberOptions.map(obj => obj.fiber).includes(str));
const colorFilter = colorFilterOptions.filter(str => fiberOptions.flatMap(obj => obj.variants.map(v => v.color)).includes(str));
// fiberFilter.push("View All");
// colorFilter.push("View All");

// Create filter by fiber dropdown
fiberFilter.forEach(function(str) {
  const html = `
  <div class="filter__option"><div class="circle-graphic circle-graphic__fiber-filter" id="fiber-circle__${str.replace(" ", "-")}"></div><div class="option__fiber" onclick="filterByFiber('${str}')" id="option__fiber-${str.replace(" ", "-")}">${str}</div></div>
  `;
  drpdnFiberFilter.insertAdjacentHTML('beforeend', html);
});

// Create filter by color dropdown
colorFilter.forEach(function(str) {
  const html = `
  <div class="filter__option"><div class="circle-graphic circle-graphic__color-filter" id="color-circle__${str.replace(" ", "-")}"></div><div class="option__color" onclick="filterByColor('${str}')" id="option__color-${str.replace(" ", "-")}">${str}</div></div>
  `;
  drpdnColorFilter.insertAdjacentHTML('beforeend', html);
})

const setFiberFilterOptions = function() {
  if (filterOptions.color === null) return document.querySelectorAll('[id^=option__fiber]').forEach(el => el.classList.remove('hidden'));
    const validFibers = fiberOptions.filter(obj => obj.variants.some(v => v.color === filterOptions.color));
    const newFiberFilter = fiberFilter.filter(str => !validFibers.map(obj => obj.fiber).includes(str));
    newFiberFilter.forEach(str => {
      document.getElementById(`option__fiber-${str.replace(" ", "-")}`).closest('.filter__option').classList.add('hidden');
    });
}

const setColorFilterOptions = function() {
  if (filterOptions.fiber === null) return document.querySelectorAll('[id^=option__color]').forEach(el => el.classList.remove('hidden'));
  const validColors = fiberOptions.filter(obj => obj.fiber === filterOptions.fiber);
  const newColorFilter = colorFilter.filter(str => !validColors.flatMap(obj => obj.variants.map(v => v.color)).includes(str));
  newColorFilter.forEach(str => {
    document.getElementById(`option__color-${str.replace(" ", "-")}`).closest('.filter__option').classList.add('hidden');
  });;
}

const setFilterOptions = function() {
  document.querySelectorAll('.filter__option').forEach(el => el.classList.remove('hidden'));
  setFiberFilterOptions();
  setColorFilterOptions();
  if (filterOptions.fiber || filterOptions.color) {
    btnFiberFilterViewAll.classList.remove('hidden')
  } else {
    btnFiberFilterViewAll.classList.add('hidden')
  }
}
setFilterOptions();

// // Set filter options
// const fiberFilter = ['Coir', 'Hemp', 'Indoor/Outdoor', 'Jute', 'Luxe', 'Seagrass', 'Sisal - Classic', 'Sisal - Designer', 'Wool', 'Wool Blends', 'Wool and Sisal', 'View All'];
// const colorFilter = ['Beige', 'Black', 'Blue', 'Brown', 'Dark Gray', 'Gray', 'Green', 'Gold', 'Honey', 'Ivory', 'Linen', 'Navy', 'Purple', 'Red', 'Spice', 'Tan', 'Taupe', 'Terra Cotta', 'Yellow', 'View All']

// // Create filter by fiber dropdown
// fiberFilter.forEach(function(str) {
//   const html = `
//     <a href="javascript:;" onclick="filterByFiber('${str}')" class="option__fiber">${str}</a>
//   `;
//   drpdnFiberFilter.insertAdjacentHTML('beforeend', html);
// });

// // Create filter by color dropdown
// colorFilter.forEach(function(str) {
//   const html = `
//     <a href="javascript:;" onclick="filterByColor('${str}')" class="option__fiber">${str}</a>
//   `;
//   drpdnColorFilter.insertAdjacentHTML('beforeend', html);
// })

// Render rug pads
const setPads = function() {
  rugPadContainer.innerHTML = '';
  for (const [key, value] of Object.entries(rugPads)) {
    const html = `
     <div id=${key + 'pad'} class="option" onclick="pickRugPad(${key})">
      ${value.name}
     <img src=${value.img} width="180px" height="180px" />
      </div>
    `
    rugPadContainer.insertAdjacentHTML('beforeend', html)
  }
}
setPads()

const showRugSavedPopup = function() {
  popupContainer.classList.toggle('invisible');
  popupContainer.classList.toggle('popup__blur');
}

// Edit rug from saved rugs
const editRug = async function() {
  const rugToEdit = localStorage.getItem('rugID');
  if (!rugToEdit) return;
  designRug = savedRugs.find(rug => rug.id === rugToEdit);
  try {
    const productEl = Array.from(optionContainer.querySelectorAll('.option')).find(el => el.dataset.productCamel === designRug.fiberNameCamel);
    const prodID = productEl.dataset.productId;
    const handle = productEl.id;
    const camel = productEl.dataset.productCamel;
    const variants = await getVariantInfo('/api/2024-01/graphql.json', prodID);
    renderVariantOptions(variants, handle, prodID, camel);
    const myProduct = Array.from(variantChoice.querySelectorAll('.option')).find(el => el.dataset.variant === designRug.color);
    const myBorder = Object.values(borderProducts).find(prod => prod.name === designRug.borderType);
    const myCornerStyle = designRug.cornerStyle;
    const myCornerSize = designRug.cornerSize;
    const rugPadArrLength = designRug.padIncluded.split(' ').length;
    const myRugPadNum = designRug.padIncluded.split(' ')[rugPadArrLength - 1] === 'None' ? 1000 : designRug.padIncluded.split(' ')[rugPadArrLength - 1];
    updateRugMaterial(myProduct.dataset.product, myProduct.dataset.variant, myProduct.dataset.productid, myProduct.dataset.variantid, myProduct.dataset.excludeSerging, myProduct.dataset.rugPadOptions.replaceAll('"]', '').replaceAll('["', '').split(','), myProduct.dataset.retired);
    if (myBorder.name === 'Serging') {
      updateBorderSerging(false);
    } else {
      updateBorder(myBorder, Object.values(myBorder.variants).find(v => v.sku === designRug.borderSKU), false);
      updateBorderStyle(designRug.borderType.replaceAll(' ', ''), `${myCornerStyle}${myCornerSize.replaceAll(' ', '')}`, `${myCornerStyle} - ${myCornerSize}`, false);
    }
    pickRugPad(myRugPadNum, false);
    updateRugSize(designRug.rugWidthFt, designRug.rugWidthIn, designRug.rugLengthFt, designRug.rugLengthIn, false);
    rugName.value = designRug.rugName;
  } catch (error) {
    resetPrices(designRug)
    showUpdateEl('Specified Rug Not Available', 'fail', 3000);
  }
}

// Get material from product page
const getMaterial = function() {
  const data = JSON.parse(localStorage.getItem('selectedVariant'));
  if (!data) return;
  updateRugMaterial(data.product, data.variant, data.productID, data.variantID, data.excludeSerging, data.rugPadOptions);
  choiceTabs.forEach(t => t.classList.remove('choice-tabs__tab--active'));
  document.querySelector('.border-choice').classList.add('choice-tabs__tab--active');
  dyrOptionsContent.forEach(el => el.classList.remove('dyr-options__active'));
  document.querySelectorAll('[data-option="border"]').forEach(el => el.classList.add('dyr-options__active'));
  showAllBorders();
}
getMaterial();
editRug();
localStorage.removeItem('selectedVariant');
localStorage.removeItem('rugID');
Array.from(borderOptionContainer.children).sort((a,b) => a.getAttribute('data-order') - b.getAttribute('data-order')).forEach(e => borderOptionContainer.appendChild(e));